<script>
    import SwiperCore, {
        Navigation
    } from "swiper";
    import {
        // WO_STATUS_TO_BE_ASSIGNED,
        API_SVC_HOST,
        AUDITING_MEASUREMENT_UNIT_MAP
    } from "@/config/common";
    // import { Swiper, SwiperSlide } from "swiper/vue";
    // import { Plus } from '@element-plus/icons-vue'
    import "swiper/swiper-bundle.css";
    import {
        formatDatetime
    } from "@/helpers/common";
    import {
        getDeviceInfo
    } from "@/helpers/common-service";
    import {
        isNull
    } from '@/utils/common'
    import {
        workOrderList,
        getCustomerContacts,
        getAuditingDevice,
        getAuditingDeviceTree,
        instanceApi,
        auditingDetails,
        postAuditingDevice,
        postAuditingDetail,
        getAuditingDetail,
        deleteAuditingDetail,
        patchAuditingDetail,
        patchAuditingDevice,
        getAuditingDeviceMeasurement,
        postAuditingDeviceMeasurement,
        getAuditingDiagnosis,
        postAuditingService,
        postAuditingDiagnosis,
        getAuditingService,
        getFaultKnowledgeBase,
        getFaultKnowledgeBaseSolution,
        getRepairKit,
        getRepairKitComponent,
        deleteAuditingDevice,
        getAuditingConvert,
        postAuditingConvert,
        getModelList,
        postAuditingReview,
        postAuditingApproval,
        instanceAttribute,
        getInstanceDetail,
        deleteAuditingDiagnosis,
        deleteAuditingService,
        auditingCheckin
    } from "@/service";
    import _ from 'lodash'
    // import vueQr from "vue-qr/src/packages/vue-qr.vue";
    import {
        WO_TYPE
    } from "@/config/common";
    import Database from "@/views/auditing-order/components/auditingDatabase.vue";
    import Attr from "@/views/auditing-order/components/auditingAttr.vue";
    import Attr1 from "@/views/auditing-order/components/auditingAttr1.vue";
    // import WoStatusEtc from "@/views/work-order/components/widgets/wo-status-etc.vue";
    import {
        ElMessage
    } from 'element-plus'
    import {
        alertComfirm,
        successMsg,
        errorMsg
    } from "@/helpers/swal";
    import SwiperTool from "@/components/swiperTool.vue";
    import moment from "moment/moment";
    import {
        ref
    } from 'vue';
    import addUpdateAccountDialog from '@/views/customer/components/addUpdateAccountDialog.vue' // 添加联系人弹窗
    import { getLanguage } from "@/i18n";
    SwiperCore.use([Navigation]);
    export default {
        emits: [
            "refresh", "tabStatusChange",
            "tabIdChange" // 选中的 tabid
        ],
        props: {
            woData: {
                type: Object,
                default () {
                    return {}
                }
            },
            checkTabVal: {
                type: String,
                default () {
                    return '';
                }
            },
            editType: {
                type: Boolean,
                default () {
                    return false
                }
            },
            tabStatus:{
                type: String,
                default () {
                    return '';
                }  
            },
        },
        setup() {
            const userModal = ref(false);

            function toggleValue() {
                userModal.value = !userModal.value;
            }
            return {
                toggleValue,
                userModal // 导出响应式数组
            }
        },
        data() {
            return {
                // WO_STATUS_TO_BE_ASSIGNED:WO_STATUS_TO_BE_ASSIGNED,//待施工状态
                submitted: true,
                /* 分页start */
                tab_info_length: 0,
                page: 1,
                perPage: 10,
                prePageOption: [10, 20, 30, 40, 50],
                pages: [],
                WO_TYPE,
                checkTabValDec: '',
                checkTabContact:'',
                contactPerson: '',
                userOptions: [],
                userOptionsDevice: [],
                tabOptions: [{
                    title: 'Tab 1',
                    name: 1,
                    content: 'Tab 1 content'
                }],
                deviceStatusOptions: [{
                    label: this.$t('在用'),//"在用",
                    value: "在用"
                }, {
                    label: this.$t('备用'),//"备用",
                    value: "备用"
                }, {
                    label: this.$t('报废'),//"报废",
                    value: "报废"
                }],
                dataList: [],
                maintenancePackage: [],
                device: {},
                deviceImgs: [],
                qrcodeLogo: require("@/assets/images/u11.jpeg"),
                tableHeadersContact: [{
                        name: "number",
                        label: this.$t('page.auditing.contact'),//联系人
                        visible: true,
                    },
                    {
                        name: "type",
                        label: this.$t('page.auditing.contact_phone'),//联系电话
                        visible: true,
                    },
                    {
                        name: "priority",
                        label: this.$t('page.user.email'),//邮箱
                        visible: true,
                    },
                    {
                        name: "device_name",
                        label: this.$t('page.auditing.departure_time'),//"出发时间",
                        visible: true,
                    },
                    {
                        name: "device_root_sn",
                        label: this.$t('page.auditing.arrival_time'),//"到达时间",
                        visible: true,
                    },
                    {
                        name: "warranty_status",
                        label: this.$t('page.auditing.leave_time'),//"离开时间",
                        visible: true,
                    },
                ],
                equipmentInfo: [],
                equipmentInfoErrorMsg: [], // 用于表单验证
                tableHeaders: [{
                        name: "number",
                        label: this.$t('page.auditing.name'),//名称
                        visible: true,
                    },
                    {
                        name: "type",
                        label: this.$t('Type'),//"设备型号",
                        visible: true,
                    },
                    // {
                    //     name: "priority",
                    //     label: "设备名称",
                    //     visible: true,
                    // },
                    {
                        name: "device_name",
                        label: this.$t('Serial No.'), //"设备序列号",
                        visible: true,
                    },
                    {
                        name: "device_root_sn",
                        label: this.$t('page.auditing.position_no'),//"设备位号",
                        visible: true,
                    },
                    {
                        name: "warranty_status",
                        label: this.$t('page.auditing.installation_and_debugging_time'),// "安装及调试时间",
                        visible: true,
                    },
                    {
                        name: "customer_contact_name",
                        label: this.$t('page.auditing.operation_time'),// "投运时间",
                        visible: true,
                    },
                    {
                        name: "customer_contact_number",
                        label: this.$t('page.auditing.factory_release_time'),//"出厂时间",
                        visible: true,
                    },
                    {
                        name: "status",
                        label: this.$t('page.deviceStatus'),//"设备状态",
                        visible: true,
                    },
                    {
                        name: "customer_txt",
                        label: this.$t('page.auditing.uploaded_nameplate'),//"上传铭牌",
                        visible: true,
                    },
                    {
                        name: "service_company_txt",
                        label: this.$t('page.auditing.equipment_appearance'),//"设备外观",
                        visible: true,
                    },

                ],
                normalList: [],
                faultList: [],
                tableHeadersAbnormal: [{
                        name: "number",
                        label: this.$t('page.auditing.equipment'),//"设备",
                        visible: true,
                    },
                    {
                        name: "type",
                        label: this.$t('page.auditing.possible_abnormal_measurement_points'),//"可能异常测点",
                        visible: true,
                    },
                    {
                        name: "priority",
                        label: this.$t('page.auditing.fault_performance'),//"故障表现",
                        visible: true,
                    },
                    {
                        name: "device_name",
                        label: this.$t('page.auditing.preliminary_analysis_reason'),//"初步分析原因",
                        visible: true,
                    },
                    {
                        name: "device_root_sn",
                        label: this.$t('page.auditing.solution'),//"解决办法",
                        visible: true,
                    },
                    {
                        name: "attachment",
                        label: this.$t('page.attachment'),//"附件",
                        visible: true,
                    },
                ],
                tableHeadersNormal: [{
                        name: "name",
                        label: this.$t('page.auditing.equipment'),//"设备",
                        visible: true,
                    },
                    {
                        name: "remark",
                        label: this.$t('page.auditing.remarks'),//"备注",
                        visible: true,
                    },
                    {
                        name: "attachment",
                        label: this.$t('page.attachment'),//"附件",
                        visible: true,
                    }
                ],
                maintenanceSuggestionTable: [],
                tableHeadersMaintenanceSuggestion: [{
                        name: "number",
                        label: this.$t('page.auditing.equipment'),//"设备",
                        visible: true,
                    },
                    {
                        name: "type",
                        label: this.$t('page.auditing.fault_performance'),//"故障表现",
                        visible: true,
                    },
                    {
                        name: "types",
                        label: this.$t('page.auditing.maintenance_suggestions'),//"维保建议",
                        visible: true,
                    }
                ],
                sparePartsList: [],
                tableHeadersSpareParts: [{
                        name: "number",
                        label: this.$t('page.auditing.equipment'),//"设备",
                        visible: true,
                    },
                    {
                        name: "type",
                        label: this.$t('page.auditing.fault_performance'),//"故障表现",
                        visible: true,
                    },
                    {
                        name: "attachmentLevel",
                        label: this.$t('page.auditing.specification'),//"规格",
                        visible: true,
                    },
                    {
                        name: "attachmentNum",
                        label: this.$t('page.auditing.quantity'),//"用量",
                        visible: true,
                    },
                    {
                        name: "types",
                        label: this.$t('page.auditing.spare_parts_suggestions'),//"配件建议",
                        visible: true,
                    }
                ],
                upgradingList: [],
                careList: [],
                weixiuList: [],
                tihuanList: [],
                tableHeadersjigai: [{
                        name: "devices",
                        label: this.$t('page.auditing.equipment'),//"设备",
                        visible: true,
                    },
                    {
                        name: "fault_name",
                        label: this.$t('page.auditing.fault_performance'),//"故障表现",
                        visible: true,
                    },
                    {
                        name: "remark",
                        label: this.$t('page.auditing.remarks'),//"备注",
                        visible: true,
                    }
                ],
                tableHeadersUpgrading: [{
                        name: "devices",
                        label: this.$t('page.auditing.equipment'),//"设备",
                        visible: true,
                    },
                    {
                        name: "fault_name",
                        label: this.$t('page.auditing.fault_performance'),//"故障表现",
                        visible: true,
                    },
                    {
                        name: "remark",
                        label: this.$t('page.auditing.remarks'),//"备注",
                        visible: true,
                    }
                ],
                tableHeadersBusiness: [
                {
                        name: "device_name",
                        label: this.$t('page.auditing.opportunity_name'),//"商机名称",
                        visible: true,
                    },
                    {
                        name: "location",
                        label: this.$t('page.auditing.position_no'),//"设备位号",
                        visible: true,
                    },
                    {
                        name: "type",
                        label: this.$t('page.auditing.opportunity_type'),//"商机类型",
                        visible: true,
                    },
                    {
                        name: "stage",
                        label: this.$t('page.auditing.stage'),//"阶段",
                        visible: true,
                    },
                    {
                        name: "amount",
                        label: this.$t('page.auditing.estimated_value'),//"预估价值",
                        visible: true,
                    },
                    {
                        name: "possibility",
                        label: this.$t('page.auditing.order_feasibility'),//"成单可行性",
                        visible: true,
                    },
                    {
                        name: "remark",
                        label: this.$t('page.auditing.remarks'),//"备注 ",
                        visible: true,
                    }
                ],
                /* 商机阶段的承担可行性百分比 */ 
                businessStage:[
                    { value: '1', label:'per-funnel', possibility:0 },
                    { value: '2', label:'Feasibility', possibility:10 },
                    { value: '3', label:'budget', possibility:20 },
                    { value: '4', label:'firm proposal', possibility:40 },
                    { value: '5', label:'negotiation', possibility:80 },
                ],
                equipments: [],
                count: 0,
                filters: {
                    page: 1,
                    page_size: 10,
                },
                deviceList: [],
                deviceChangeList: [],
                deviceListCheckList: [],
                devicesCheckList: [],
                diagnosticMeasuringPointCheckList: [],
                serviceSuggestionDevicesCheckList: [],
                measuringPointTableData: [

                ],
                modalTitle: '',
                faultEditableTabsValue: '1',
                faultEditableTabs: [{
                    title: '故障',
                    name: '1',
                    fault_knowledge_base_id: '',
                    fault_desc: '',
                    fault_name: '',
                    files: [],
                    filesList: {
                        image: [],
                        video: [],
                        document: []
                    },
                    solutions: [{
                        fault_knowledge_base_solution_id: '',
                        fault_reason: '',
                        fault_impact: '',
                        solution: '',
                    }]
                }, ],
                tabIndex: 1,

                suggestionEditableTabsValue: '1',
                suggestionEditableTabs: [{
                        title: '建议',
                        name: '1',
                        content: 'Tab 1 content',
                        type: '',
                        maintain: {
                            suggestionType: '',
                            suggestionList: []
                        },
                        attachment: {
                            attachmentType: '',
                            attachmentLevel: '',
                            attachmentNum: '',
                            partsList: []
                        },
                        technicalReform: {
                            technicalReformModel: '',
                            desc: ''
                        },
                        care: {
                            careModel: '',
                            desc: ''
                        },
                        other: {
                            desc: ''
                        }
                    },

                ],
                suggestiontabIndex: 2,
                faultNameOptions: [{
                    value: '1',
                    label: '1'
                }],
                suggestionNameOptions: [{
                        value: '1',
                        label: this.$t('page.auditing.maintenance'),//'保养'
                    },
                    {
                        value: '2',
                        label: this.$t('page.auditing.spare_parts'),//'备件'
                    },
                    {
                        value: '3',
                        label: this.$t('page.auditing.technical_transformation'),//'技改'
                    },
                    {
                        value: '4',
                        label: 'care'
                    },
                    {
                        value: '5',
                        label: this.$t('page.auditing.repairs'),//'维修'
                    },
                    {
                        value: '6',
                        label: this.$t('page.auditing.replace'),//'替换'
                    },
                ],
                careOptions: [{
                        value: 'Package Care',
                        label: 'Package Care'
                    },
                    {
                        value: 'Planned Care',
                        label: 'Planned Care'
                    },
                    {
                        value: 'Parts Care',
                        label: 'Parts Care'
                    },
                    {
                        value: 'Service Care',
                        label: 'Service Care'
                    },
                ],
                /* 资料库 */
                files: {
                    image: [],
                    video: [],
                    document: []
                },
                filesNums: [],
                faultName: '',
                suggestionType: '',
                suggestionList: [],
                maintenanceSuggestion: '',
                maintenanceSuggestionList: {
                    '一级保养': [],
                    '二级保养': [],
                    '返厂大修': []
                },
                attachmentList: [{
                        value: '1',
                        label: '1'
                    },
                    {
                        value: '2',
                        label: '2'
                    },
                    {
                        value: '3',
                        label: '3'
                    },
                    {
                        value: '4',
                        label: '4'
                    },
                    {
                        value: '5',
                        label: '5'
                    },
                ],
                partsList: [],
                orderInfo: {},
                /* 未分配单体设备 */
                notAssigned:0,
                percentageNum:0,/* 未分配单体设备百分比 */ 
                pointTypeList: [
                    "入口压力",
                    "出口压力",
                    "工作液温度",
                    "电流",
                    "电机轴承温度",
                    "电机轴承振动",
                    "泵驱动端轴承温度",
                    "泵非驱动端轴承温度",
                    "泵驱动端轴承水平振动",
                    "泵驱动端轴承垂直振动",
                    "泵非驱动端轴承水平振动",
                    "泵非驱动端轴承垂直振动",
                    "泵非驱动端轴承轴向振动"
                ],
                unitList: AUDITING_MEASUREMENT_UNIT_MAP,
                devices: [],
                serviceSuggestionDevices: [],
                knowledgeBase: [],
                knowledgeBaseSolution: [],
                faultType: false,
                diagnosticMeasuringPoint: [],
                faultManifestation: [],
                businessOpportunityConversion: [],
                setProps: {
                    checkStrictly: true,
                    expandTrigger: "hover",
                    value: "id",
                    label: "name",
                },
                objModelInfo: [],
                dialogVisible: false,
                dialogImageUrl: '',
                approvals1: false,
                approvals2: false,
                approvals3: false,
                businessOpportunityConversionAmount: 0,
                devicesType: null,
                serviceType: null,
                equipmentFilter: [],
                normalFaultIdList: [],
                diagnosisIdList: [],
                examineDec: '',
                examineModal: false,
                examineType: '',
                equipmentUserFilter: [],
                faultEditFilter: [],
                knowledgeBaseSolutionFilter: [],
                flag: true,

                // 添加联系人
                addUpdateAccountDialogInfo: {
                    title: '',
                    visible: false,
                    formType: 'add', // 新增
                    formData: {}
                },
                equipmentCount: 0,
                /* 商机转换操作 */ 
                businessFormModel:{},
                // 维修等级
                repairLevel:{
                    '3':this.$t('page.auditing.repair_level.overhauls'),//'大修',
                    '2':this.$t('page.auditing.repair_level.medium_repair'),//'中修',
                    '1':this.$t('page.auditing.repair_level.minor_repairs'),//'小修'
                },
                //建议类型
                sugType:{
                    '1':this.$t('page.auditing.maintenance'),//'保养',
                    '2':this.$t('page.auditing.spare_parts'),//'备件',
                    '3':this.$t('page.auditing.technical_transformation'),//'技改',
                    '4':'care',
                    '5':this.$t('page.auditing.repairs'),//'维修',
                    '6':this.$t('page.auditing.replace'),//'替换'
                },
                //modalTitle 弹框标题国际化
                modalTitleI18:{
                    '商机转换':this.$t('page.auditing.opportunity_conversion'),
                    '联系人':this.$t('page.auditing.contact'),
                    '设备列表':this.$t('page.auditing.equipment_list'),
                    '设备测点':this.$t('page.auditing.measurements'),
                    '诊断记录':this.$t('page.auditing.Diagnostic Records'),
                    '服务建议':this.$t('page.auditing.service_suggestions'),
                }
            }
        },
        mounted() {
            this.getAuditingDetails('first')
            this.getCustomerContacts()
            this.getModelLists()
            // document.getElementById('zoombox').style.MozTransform = 'scale(0.5 0.5)';
            // document.getElementById('zoombox').style.MozTransformOrigin = 'top left';

        },
        methods: {
            deviceStatusClick(item) {
                item["isShow"] = !item["isShow"]
                const item_id = item.id
                for (var a of this.equipmentInfo) {
                    if (item_id == a.parent_id) {
                        a["isShow"] = item["isShow"]
                    }
                }
                // const device_type = item.device_attributes.device_type
                // for (var a of this.equipmentInfo) {
                //     const device_attributes = a.device_attributes
                //     if (device_attributes) {
                //         if (device_type == device_attributes.group_type) {
                //             a["isShow"] = item["isShow"]
                //         }
                //     }
                // }
            },
            //#region 表单验证相关

            // 当前值校验是否不通过
            isInvalid(obj, path = '') {
                return _.get(obj, path)
            },
            equipmentInfoIsInvalid(index, key) {
                return this.isInvalid(this.equipmentInfoErrorMsg, [index, key])
            },

            // 表单提交前 - 验证设备信息 -- 
            // 比较low的校验...
            validateDeviceInfo() {
                let bool = true
                this.equipmentInfo.map((item, index) => {
                    if (item.product_type == 2) {
                        this.equipmentInfoErrorMsg[index] || (this.equipmentInfoErrorMsg[index] = {})
                        let validateFields = ['install_time', 'release_time', 'production_time']
                        validateFields.map(subItem => {
                            if (isNull(item[subItem]) || Array.isArray(item[subItem]) && !item[subItem]
                                .length) {
                                this.equipmentInfoErrorMsg[index][subItem] = '必填'
                                bool = false
                            }
                        })
                    } else {
                        this.equipmentInfoErrorMsg[index] || (this.equipmentInfoErrorMsg[index] = {})
                        let validateFields = ['install_time', 'release_time', 'production_time',
                            'nameplate_attachment', 'appearance_attachment'
                        ]
                        validateFields.map(subItem => {
                            if (isNull(item[subItem]) || Array.isArray(item[subItem]) && !item[subItem]
                                .length) {
                                this.equipmentInfoErrorMsg[index][subItem] = '必填'
                                bool = false
                            }
                        })
                    }
                })
                return bool
            },
            // 验证所有信息
            validate() {
                if (!this.validateDeviceInfo()) {
                    // ElMessage({ grouping: true, type: "error", message: '请填写设备信息!'});
                    errorMsg(this.$t("page.auditing['请填写设备信息']"))
                    return false
                }
                // ...

                // 验证通过
                this.clearValidate()
                return true
            },
            // 清除验证信息
            clearValidate() {
                // 清除设备信息校验
                this.equipmentInfoErrorMsg = []
            },

            // #endregion 表单验证相关

            //#region 添加联系人相关

            // 添加联系
            addContactPerson() {
                let belong_id = this.woData.customer
                if (!belong_id) return errorMsg(`belong_id ${this.$t("page.auditing['不存在']")}！`)
                this.addUpdateAccountDialogInfo = {
                    visible: true,
                    title: this.$t('page.auditing.add_new_contact'),
                    formType: 'add', // 新增
                    formData: {
                        role_id: null,
                        email: null,
                        username: null,
                        first_name: null,
                        last_name: null,
                        tel: null,
                        tags: '',
                        department: '',
                        position: '',
                        belong_id,
                        belong_type: 'customer',
                    }
                }
            },
            // 添加联系人成功回调
            addUpdateAccountSuccessed() {
                this.getCustomerContacts()
            },
            //#endregion 添加联系人相关

            handleSelect(selection, row) {
                if (row.children && row.children.length > 0) {
                    row.children.map(item => {
                        this.$refs.xTable.toggleRowSelection(item, false)
                    })
                }
                selection = this.$refs.xTable.getSelectionRows()
                this.deviceListCheckList = selection
            },
            cellClass(row) {
                if (row.columnIndex === 0) {
                    return 'DisableSelection'
                }
            },
            callbackDevices(row) {
                if (this.devicesType) {
                    return row.root_model === this.devicesType
                } else {
                    return true
                }


            },
            handleSelectionDevices(selection, row) {
                this.knowledgeBase = [];
                this.knowledgeBaseSolution = [];
                if (row.children && row.children.length > 0) {
                    row.children.map(item => {
                        this.$refs.dTable.toggleRowSelection(item, false)
                    })
                }
                selection = this.$refs.dTable.getSelectionRows()
                this.devicesCheckList = selection
                if (this.devicesCheckList.length > 0) {
                    this.devicesType = this.devicesCheckList[0].root_model
                    this.getFaultKnowledgeBases(this.devicesCheckList[0].root_model)
                } else {
                    this.devicesType = null
                }
                this.diagnosticMeasuringPoint = []
                this.diagnosticMeasuringPointCheckList = []
                this.measuringPointTableData.map(item => {
                    this.devicesCheckList.map(b => {
                        if (b.id == item.device.did) {
                            this.pointTypeList.map(a => {
                                if (item.device.data[a]['s'] == '3' || item.device.data[a][
                                        's'
                                    ] == '2') {
                                    this.diagnosticMeasuringPoint.push({
                                        device: item.device.did,
                                        device_location: item.location,
                                        key: a,
                                        value: item.device.data[a]['v'],
                                        status: item.device.data[a]['s']
                                    })

                                }
                            })
                        }
                    })
                })
                this.$nextTick(() => {
                    this.diagnosticMeasuringPoint.map(item => {
                        //toggleRowSelection:用于多选表格，切换某一行的选中状态， 如果使用了第二个参数，则可直接设置这一行选中与否
                        this.$refs.diagnosticMeasuringPointTable.toggleRowSelection(item, true)
                    })
                    //getSelectionRows:返回当前选中的行
                    this.diagnosticMeasuringPointCheckList = this.$refs.diagnosticMeasuringPointTable
                        .getSelectionRows()
                })
            },
            callbackService(row) {
                if (this.serviceType) {
                    return row.model === this.serviceType
                } else {
                    return true
                }
            },
            handleSelectionService(selection, row) {
                this.faultManifestation = []
                if (row.children && row.children.length > 0) {
                    row.children.map(item => {
                        this.$refs.sTable.toggleRowSelection(item, false)
                    })
                }
                selection = this.$refs.sTable.getSelectionRows()
                this.serviceSuggestionDevicesCheckList = selection

                if (this.serviceSuggestionDevicesCheckList.length > 0) {
                    this.faultList.map(item => {
                        item.devices.map(d => {
                            this.serviceSuggestionDevicesCheckList.map(s => {
                                if (d.id == s.id) {
                                    item.diagnosis.map(a => {
                                        if (a.fault_name.length > 0) {
                                            this.faultManifestation.push({
                                                label: a.fault_name,
                                                value: a.fault_name,
                                                devices: item.devices
                                            })
                                        }
                                    })
                                }
                            })

                        })

                    })
                    this.faultManifestation = this.faultManifestation.filter((item, index) =>
                        this.faultManifestation.findIndex(i => i.label === item.label) === index);
                    this.serviceType = this.serviceSuggestionDevicesCheckList[0].model
                    this.maintenanceSuggestionList['一级保养'] = []

                    this.maintenanceSuggestionList['二级保养'] = []

                    this.maintenanceSuggestionList['返厂大修'] = []

                    getInstanceDetail(this.serviceSuggestionDevicesCheckList[0].id).then(res => {
                        if (res.payload && res.payload.repairs) {
                            _.cloneDeep(res.payload).repairs.map(item => {
                                if (item.name == '1') {
                                    this.maintenanceSuggestionList['一级保养'].push({
                                        label: item.item_name,
                                        value: item.item_name
                                    })
                                }
                                if (item.name == '2') {
                                    this.maintenanceSuggestionList['二级保养'].push({
                                        label: item.item_name,
                                        value: item.item_name
                                    })
                                }
                                if (item.name == '3') {
                                    this.maintenanceSuggestionList['返厂大修'].push({
                                        label: item.item_name,
                                        value: item.item_name
                                    })
                                }
                            })

                        }
                    })
                } else {
                    this.serviceType = null
                }
            },

            imgList(arr) {
                let list = []
                arr.map(item => {
                    list.push(item.url)
                })
                return list
            },
            postAuditingReviews(type) {
                this.examineType = type
                if(this.examineType == '1'){ //通过时校验
                    /* 商机转换：预估金额或成单可行性未填写完成，无法提交审核 */ 
                    if(this.businessOpportunityConversion.some(ev=>String(ev.amount) == '' || String(ev.possibility) == '')){
                        this.approvals3 = false
                    }else{ //校验通过
                        this.approvals3 = true
                    }

                    if (!this.approvals3) {
                        ElMessage({
                            type: "error",
                            message: this.$t("page.auditing['商机转换未填写，请填写完整后提交审核']")
                        });
                       return; 
                    }
                    
                }
                this.examineModal = !this.examineModal
            },
            savePostAuditingReviews() {
                let params = {
                    order_id: this.$route.params.id,
                    detail_id: this.checkTabValDec,
                    result: this.examineType,
                    reason: this.examineDec
                }

                postAuditingReview(params).then(res => {
                    console.log(res)
                    this.examineModal = !this.examineModal
                    successMsg(this.$t('base.operate_success'))
                    this.$emit('refresh')
                    this.getAuditingDetails()
                    this.getCustomerContacts()
                    this.getModelLists()
                    this.getAuditingDiagnosis()
                }).catch(() => {
                    errorMsg(this.$t("page.auditing['服务过程未完成']"))
                })
            },
            //提交审核
            postAuditingApprovals() {
                /* 服务建议是否填写完毕：服务建议是否还有未完成的数量 */ 
                let serviceRecommend = this.normalFaultIdList && this.normalFaultIdList.length === this.diagnosisIdList
                    .length

                /* 诊断记录：是否为空，校验诊断记录是否还有未完成的数量 */

                if( ((this.normalList && this.normalList.length > 0) || (this.faultList && this.faultList.length > 0))
                &&((this.equipmentInfo.length>0?(this.equipmentCount-this.diagnosisIdList.length):0) == 0)){
                    this.approvals1 = true 
                }else{
                    this.approvals1 = false
                }
                
                /* 商机转换：预估金额或成单可行性未填写完成，无法提交审核 */ 
                // if(this.businessOpportunityConversion.some(ev=>String(ev.amount) == '' || String(ev.possibility) == '')){
                //     this.approvals3 = false
                // }else{ //校验通过
                //     this.approvals3 = true
                // }
                

                /**
                 * 诊断记录：approvals1，
                 * 服务建议：serviceRecommend，
                 * 商机转换：approvals3，
                 * */ 

                if (this.approvals1 && serviceRecommend && this.approvals3 && this.checkTabValDec) {
                    let params = {
                        order_id: this.$route.params.id,
                        detail_id: this.checkTabValDec
                    }
                    postAuditingApproval(params).then(res => {
                        console.log(res)
                        successMsg(this.$t('base.operate_success'))
                        this.$emit('refresh')
                        this.getAuditingDetails()
                        this.getCustomerContacts()
                        this.getModelLists()
                        this.getAuditingDiagnosis()
                    })
                } else {
                    if (!this.approvals1) {
                        ElMessage({
                            type: "error",
                            message: this.$t("page.auditing['诊断记录未填写完整']")
                        });
                    }
                    if (!serviceRecommend) {
                        ElMessage({
                            type: "error",
                            message: this.$t("page.auditing['服务建议未填写完整']")
                        });
                    }
                    if (!this.approvals3) {
                        ElMessage({
                            type: "error",
                            message: this.$t("page.auditing['商机转换未填写']")
                        });
                    }
                }
            },
            handlePictureCardPreview(uploadFile) {
                console.log(uploadFile)
                this.dialogImageUrl = uploadFile.url
                this.dialogVisible = true
            },
            handleRemove(uploadFile, uploadFiles) {
                console.log(uploadFile, uploadFiles)
            },
            //设备型号
            getModelLists() {
                let params = {
                    type: 1
                }
                getModelList(params).then(res => {
                    this.objModelInfo = _.cloneDeep(res.payload).data
                })
            },
            handleTabsChange() {
                this.faultEditableTabs.map(item => {
                    if (item.name == this.faultEditableTabsValue) {
                        this.files = item.filesList
                        this.filesNums = item.files
                    }
                })
            },
            filesChange({
                files,
                id,
                filesNums
            }) {

                this.faultEditableTabs.map(item => {
                    if (item.name == id) {
                        item.filesList = files
                        item.files = filesNums
                    }
                })


            },
            filesimgChange({
                setObj,
                filesNum,
                setType,
                delFiles
            }) {
                let attachment = filesNum || []
                if (delFiles) { // 删除附件
                    attachment = []
                } else {
                    if (setType == '2') {
                        if (setObj.appearance_attachment && setObj.appearance_attachment.length > 0) {
                            setObj.appearance_attachment.map(item => {
                                attachment.push(item.id)
                            })
                        }
                    } else {
                        if (setObj.nameplate_attachment && setObj.nameplate_attachment.length > 0) {
                            setObj.nameplate_attachment.map(item => {
                                attachment.push(item.id)
                            })
                        }
                    }
                }

                let params = {
                    install_time: setObj.install_time,
                    release_time: setObj.release_time,
                    production_time: setObj.production_time,
                    attachment: attachment,
                    attachment_type: setType,
                }
                patchAuditingDevice(setObj.id, params).then(res => {
                    console.log(res)
                    if (delFiles) { // 删除
                        ElMessage.success(setType === '1' ?  this.$t("page.auditing['铭牌删除成功']") :  this.$t("page.auditing['设备外观删除成功']"))
                    } else {
                        ElMessage.success(setType === '1' ? this.$t("page.auditing['铭牌上传成功']") :  this.$t("page.auditing['设备外观上传成功']"))
                    }

                    this.getAuditingDevices()
                })
            },
            //联系人列表
            getAuditingDetails(type) {

                getAuditingDetail({
                    order: this.$route.params.id
                }).then(ress => {
                    this.tabOptions = ress.payload.results
                    if (this.tabOptions.length > 0) {
                        this.tabOptions.map(item => {
                            item['title'] = item.contact_name
                            item['name'] = item.id
                        })
                        if (type) {
                            this.checkTabValDec = this.tabOptions[0].id
                            this.checkTabContact = this.tabOptions[0].contact
                        }
                        this.tabOptions.map(item => {
                            if (item.id === this.checkTabValDec) {
                                this.$emit('tabStatusChange', item.status)
                            }
                        })
                        // console.log('~~~~~~~~~联系人tab~~~~~~',this.tabOptions);
                        this.getAuditingServices()
                        this.getRepairKits()
                        this.getAuditingConverts()
                        this.getAuditingDevices()
                        this.getAuditingDiagnosis()
                        this.getInstanceApis()
                    }
                })
            },
            //联系人时间修改
            contactTime(item) {
                let params = {
                    departure_time: item.departure_time,
                    arrival_time: item.arrival_time,
                    leave_time: item.leave_time
                }
                patchAuditingDetail(item.id, params).then(res => {
                    console.log(res)
                    this.getAuditingDetails()
                })
            },
            //获取联系人列表
            getCustomerContacts() {
                auditingDetails(this.$route.params.id).then(res => {
                    this.orderInfo = _.cloneDeep(res.payload)
                    /* 计算未分配设备数量 */ 
                    let device = this.orderInfo.not_assigned_device
                    if(device){
                        this.notAssigned = device.not_assigned
                        this.percentageNum = ((device.count-device.not_assigned)/device.count*100).toFixed(2) == '0.00'? 0 : ((device.count-device.not_assigned)/device.count*100).toFixed(2)
                    }

                    let params = {
                        customer: res.payload.customer,
                        label: '设备联系人' // 设备联系人
                    }
                    getCustomerContacts(params).then(res => {
                        if (res && res.payload && res.payload.results) {

                            this.userOptions = res.payload.results
                            this.userOptions.map(item => {
                                item['label'] = item.name
                                item['value'] = item.id
                                item['disabled'] = false
                                this.tabOptions.map(a => {

                                    if (item.id === a.contact) {
                                        item['disabled'] = true
                                    }
                                })

                            })
                            this.userOptionsDevice = res.payload.results.filter(item=>item.id === this.checkTabContact)
                            this.userOptionsDevice.map(item => {
                                item['label'] = item.name
                                item['value'] = item.id
                            })


                        }
                    })
                }).catch(err => {
                    console.log(err)
                })


            },
            //设备列表
            getAuditingDevices() {
                this.equipmentInfoErrorMsg = [] // 清除设备信息校验
                /* 无数结构数据 */ 
                getAuditingDevice({order: this.$route.params.id,page_size: 999999}).then(res=>{
                    if (res && res.payload && res.payload){
                       let allDevideList = res.payload.results //所有被选联系人设备数据

                        /* 过滤出当前联系人绑定的设备----已被选择的设备device */ 
                        let list_equipmentFilter = [],
                            reslut = [];
                        allDevideList.map(a => {
                            list_equipmentFilter.push(a.device)
                            if(a.detail === this.checkTabValDec){
                                reslut.push(a)
                            }
                        })
                        this.equipmentFilter = list_equipmentFilter  
                        if(reslut.length === 0){
                            this.equipmentFilter = []  
                        }
                    }else{
                      this.equipmentFilter = []  
                    }
                })
                /* 数结构数据（children） */ 
                getAuditingDeviceTree({order: this.$route.params.id,detail:this.checkTabValDec}).then(res=>{
                    if (res && res.payload && res.payload){
                        let reslut = res.payload
                        if(reslut.length){
                            this.tabOptions.map(item => {
                                if (this.checkTabValDec === item.id) {
                                    this.equipmentInfo = _.cloneDeep(reslut)

                                    let list_equipmentUserFilter = []
                                    this.equipmentInfo.map(a => {
                                        const children = a.children
                                        if (children && children.length > 0) {
                                            children.map(b => {
                                                if (b.product_type == '1') {
                                                    list_equipmentUserFilter.push(b.device)
                                                }
                                            })
                                        } else {
                                            if (a.product_type == '1') {
                                                list_equipmentUserFilter.push(a.device)
                                            }
                                        }
                                    })
                                    this.equipmentUserFilter = list_equipmentUserFilter
                                    /* 关键点 */ 
                                    let equipmentList = []
                                    // let otherList = []
                                    let equipmentCount = 0
                                    this.equipmentInfo.map(a => {
                                        const children = a.children
                                        a["isShow"] = true
                                        a["isParent"] = true
                                        a["parent_id"] = ""
                                        if (children && children.length > 0) {
                                            a["hasChild"] = true
                                            equipmentList.push(a)
                                            children.map(b => {
                                                b["isShow"] = true
                                                b["isParent"] = false
                                                b["hasChild"] = false
                                                b["parent_id"] = a.id
                                                b["parent_device_name"] = a.device_name
                                                equipmentList.push(b)
                                                if (b.product_type == '1') {
                                                    equipmentCount += 1
                                                }
                                            })
                                        } else {
                                            a["hasChild"] = false
                                            equipmentList.push(a)
                                            if (a.product_type == '1') {
                                                equipmentCount += 1
                                            }
                                        }
                                    })
    
                                    this.equipmentInfo = equipmentList
                                    this.equipmentCount = equipmentCount
    
                                }
                            })
                        }else{
                            this.equipmentInfo = []
                            this.equipmentCount = 0
                            this.equipmentUserFilter = []
                        }
                    }else{
                        this.equipmentInfo = []
                        this.equipmentCount = 0
                        this.equipmentUserFilter = []
                    }
                }) 

            },
            // getAuditingDevices() {
            //     /* 数据刷新是页面闪动 */ 
            //     // this.equipmentFilter = []
            //     // this.equipmentUserFilter = []
            //     // this.equipmentInfo = []
            //     this.equipmentInfoErrorMsg = [] // 清除设备信息校验
            //     this.tabOptions.map(item => {
            //         let params = {
            //             order: this.$route.params.id,
            //             detail: item.id,
            //             page_size: 0
            //         }
            //         getAuditingDevice(params).then(res => {

            //             if (res && res.payload && res.payload.length > 0) {
            //                 if (this.checkTabValDec === item.id) {
            //                     this.equipmentInfo = _.cloneDeep(res.payload)

            //                     let list_equipmentUserFilter = []
            //                     this.equipmentInfo.map(a => {
            //                         const children = a.children
            //                         if (children && children.length > 0) {
            //                             children.map(b => {
            //                                 if (b.product_type == '1') {
            //                                     list_equipmentUserFilter.push(b.device)
            //                                 }
            //                             })
            //                         } else {
            //                             if (a.product_type == '1') {
            //                                 list_equipmentUserFilter.push(a.device)
            //                             }
            //                         }
            //                     })
            //                     this.equipmentUserFilter = list_equipmentUserFilter
            //                     /* 关键点 */ 
            //                     let equipmentList = []
            //                     // let otherList = []
            //                     let equipmentCount = 0
            //                     this.equipmentInfo.map(a => {
            //                         const children = a.children
            //                         a["isShow"] = true
            //                         a["isParent"] = true
            //                         a["parent_id"] = ""
            //                         if (children && children.length > 0) {
            //                             a["hasChild"] = true
            //                             equipmentList.push(a)
            //                             children.map(b => {
            //                                 b["isShow"] = true
            //                                 b["isParent"] = false
            //                                 b["hasChild"] = false
            //                                 b["parent_id"] = a.id
            //                                 b["parent_device_name"] = a.device_name
            //                                 equipmentList.push(b)
            //                                 if (b.product_type == '1') {
            //                                     equipmentCount += 1
            //                                 }
            //                             })
            //                         } else {
            //                             a["hasChild"] = false
            //                             equipmentList.push(a)
            //                             if (a.product_type == '1') {
            //                                 equipmentCount += 1
            //                             }
            //                         }
            //                     })
            //                     // this.equipmentInfo.map(a => {
            //                     //     let device_info = JSON.parse(a.device_info)
            //                     //     a["device_info"] = device_info
            //                     //     a["isShow"] = true
            //                     //     a["isParent"] = true
            //                     //     a["hasChild"] = false
            //                     //     const device_attributes = a.device_attributes

            //                     //     if (device_attributes && (device_attributes.product_type ==
            //                     //             '2' || (device_attributes.product_type == '1' &&
            //                     //                 device_attributes.group_type == ''))) {
            //                     //         equipmentList.push(a)
            //                     //     } else {
            //                     //         otherList.push(a)
            //                     //     }
            //                     // })
            //                     // otherList.map(a => {
            //                     //     const device_attributes = a.device_attributes
            //                     //     if (device_attributes) {
            //                     //         let index = -1
            //                     //         for (var i in equipmentList) {
            //                     //             const b = equipmentList[i]
            //                     //             if (device_attributes.group_type == b
            //                     //                 .device_attributes.device_type) {
            //                     //                 a["isParent"] = false
            //                     //                 b["hasChild"] = true
            //                     //                 index = parseInt(i) + 1
            //                     //                 break
            //                     //             }
            //                     //         }
            //                     //         if (index != -1) {
            //                     //             equipmentList.splice(index, 0, a)
            //                     //         } else {
            //                     //             equipmentList.push(a)
            //                     //         }
            //                     //     } else {
            //                     //         equipmentList.push(a)
            //                     //     }
            //                     // })

            //                     this.equipmentInfo = equipmentList
            //                     this.equipmentCount = equipmentCount

            //                 }
            //                 let list_equipmentFilter = []
            //                 res.payload.map(a => {
            //                     list_equipmentFilter.push(a.device)
            //                 })
            //                 console.log('设备列表getAuditingDevices',res.payload);
            //                 this.equipmentFilter = list_equipmentFilter
                            
            //             }else{
            //                 this.equipmentInfo = []
            //                 this.equipmentCount = 0
            //                 this.equipmentFilter = []
            //                 this.equipmentUserFilter = []
            //             }
                        
            //         })
            //     })

            // },
            //设备时间修改
            devicesTime(item, time_type) {
                if (item.isParent) {
                    let callbackList = [];
                    let tlist = []
                    let params = {
                        id: item.id,
                        data: {
                            install_time: item.install_time,
                            release_time: item.release_time,
                            production_time: item.production_time
                        }
                    }
                    tlist.push(params)
                    const item_id = item.id
                    this.equipmentInfo.map(item1 => {
                        if (item1.isParent == false) {
                            if (item_id == item1.parent_id) {
                                let tparams = {
                                    id: item1.id,
                                    data: {
                                        install_time: item1.install_time,
                                        release_time: item1.release_time,
                                        production_time: item1.production_time
                                    }
                                }
                                tparams.data[time_type] = item[time_type]
                                tlist.push(tparams)
                            }
                        }
                    })

                    tlist.map(item1 => {
                        callbackList.push(new Promise((resolve, reject) => {
                            patchAuditingDevice(item1.id, item1.data).then(res => {
                                console.log(res)
                                return resolve({});
                            }).catch((err) => {
                                console.log(err);
                                return reject(err);
                            });
                        }))
                    })
                    Promise.allSettled(callbackList).then((res) => {
                        console.log(res)
                        this.getAuditingDevices()
                    })
                } else {
                    let params = {
                        install_time: item.install_time,
                        release_time: item.release_time,
                        production_time: item.production_time
                    }
                    patchAuditingDevice(item.id, params).then(res => {
                        console.log(res)
                        this.getAuditingDevices()
                    })
                }
            },
            setDeviceStatus(item) {
                console.log(item)
                if (item.isParent) {
                    let callbackList = [];
                    let tlist = []
                    let params = {
                        id: item.device,
                        data: {
                            name: "设备状态",
                            value: item.device_attributes.device_status
                        }
                    }
                    tlist.push(params)
                    const item_id = item.id
                    this.equipmentInfo.map(item1 => {
                        if (item1.isParent == false) {
                            if (item_id == item1.parent_id) {
                                let tparams = {
                                    id: item1.device,
                                    data: {
                                        name: "设备状态",
                                        value: item.device_attributes.device_status
                                    }
                                }
                                tlist.push(tparams)
                            }
                        }
                    })

                    tlist.map(item1 => {
                        callbackList.push(new Promise((resolve, reject) => {
                            instanceAttribute(item1.id, item1.data).then(res => {
                                console.log(res)
                                return resolve({});
                            }).catch((err) => {
                                console.log(err);
                                return reject(err);
                            });
                        }))
                    })
                    Promise.allSettled(callbackList).then((res) => {
                        console.log(res)
                        this.getAuditingDevices()
                    })
                } else {
                    let params = {
                        name: "设备状态",
                        value: item.device_attributes.device_status
                    }
                    instanceAttribute(item.device, params).then(res => {
                        console.log(res)
                        this.getAuditingDevices()
                    })
                }
            },
            //删除设备信息
            deleteMeasuringPoint(item) {
                // deleteAuditingDevice(item.id).then(res => {
                //     console.log(res)
                //     successMsg(this.$t('base.operate_success'))
                //     this.getAuditingDevices()
                //     this.getAuditingDiagnosis()
                //     this.getAuditingServices()
                //     this.getInstanceApis()
                // })

                let callbackList = [];
                let tlist = []
                tlist.push(item.id)
                const item_id = item.id
                this.equipmentInfo.map(item1 => {
                    if (item1.isParent == false) {
                        if (item_id == item1.parent_id) {
                            tlist.push(item1.id)
                        }
                    }
                })
                tlist.map(item1 => {
                    callbackList.push(new Promise((resolve, reject) => {
                        deleteAuditingDevice(item1).then(res => {
                            console.log(res)
                            return resolve({});
                        }).catch((err) => {
                            console.log(err);
                            return reject(err);
                        });
                    }))
                })
                Promise.allSettled(callbackList).then((res) => {
                    console.log(res)
                    successMsg(this.$t('base.operate_success'))
                    this.getAuditingDevices()
                    this.getAuditingDiagnosis()
                    this.getAuditingServices()
                    this.getInstanceApis()
                })
            },
            //取出包裹数据
            getFilterMenu(data) {
                let result = [];
                let queue = data;
                while (queue.length > 0) {
                    [...queue].forEach((child) => {
                        queue.shift();
                        result = result.concat([child]);
                        child.children && queue.push(...child.children);
                    });
                }
                return result
            },
            filterMenu(menuList, menuCode, type) {
                return menuList.filter(item => {
                    if (type) {
                        return menuCode.indexOf(item.id) === -1
                    } else {
                        return menuCode.indexOf(item.id) > -1
                    }
                })
            },
            filterMenuPlus(menuList, menuCode) {
                return menuList.filter(item =>menuCode.indexOf(item.id) === -1)
            },
            sortArr(arr) {
                return arr.sort(function(a, b) {
                    if (a.isNormal && !b.isNormal) return -1; // a在b之前
                    else if (!a.isNormal && b.isNormal) return 1; // b在a之前
                    else return 0; // 保持原有位置不变
                });
            },
            /* 过滤未被分配的设备列表，包含报废状态的设备 */ 
            formatDeviceList(payload) {
                let tpayload = _.cloneDeep(payload)
                for (var item of tpayload) {
                    let children = item.children || []
                    item["isParent"] = true
                    item["parentId"] = ""
                    for (var subitem of children) {
                        subitem["parentId"] = item.id
                        subitem["isParent"] = false
                    }
                }

                let deviceList = []
                /* 当前联系人绑定的设备列表 */ 
                if(this.equipmentFilter.length){ 
                    let reslutFilter = this.getFilterMenu(tpayload)
                    deviceList = this.filterMenuPlus(reslutFilter, this.equipmentFilter)
                }else{
                    deviceList = tpayload

                }

                deviceList = deviceList.filter(_sub => _sub.isParent == true)

                this.deviceList = deviceList
                this.deviceChangeList = []
            },
            formatDiagnosisDeviceList(payload) {

                let allDevice = _.cloneDeep(payload)
                allDevice.map(a => {
                    const children = a.children
                    if (children && children.length > 0) {
                        children.map(b => {
                            b.group_name = a.name
                        })
                    } else {
                        a.group_name = "-"
                    }
                })

                let tallDevice = this.getFilterMenu(allDevice)

                this.devices = this.equipmentInfo.length > 0 ? this.filterMenu(this.filterMenu(
                        tallDevice, this.equipmentUserFilter, false), this.diagnosisIdList,
                    true) : []
                this.devices.map(item => {
                    item['isNormal'] = false
                    if (item.children && item.children.length > 0) {
                        item.children = []
                    }
                    item['score'] = 0
                    item['submitted'] = false
                })

            },
            formatSuggestionDeviceList(payload) {
                let allDevice = _.cloneDeep(payload)
                allDevice.map(a => {
                    const children = a.children
                    if (children && children.length > 0) {
                        children.map(b => {
                            b.group_name = a.name
                        })
                    } else {
                        a.group_name = "-"
                    }
                })

                let tallDevice = this.getFilterMenu(allDevice)
                this.serviceSuggestionDevices = this.filterMenu(this.filterMenu(tallDevice, this
                    .diagnosisIdList, false), this.normalFaultIdList, true)
            },
            /* 获取客户所有设备列表 */
            getInstanceApis() {
                auditingDetails(this.$route.params.id).then(res => {
                    let params = {
                        id: res.payload.customer
                    }
                    instanceApi(params).then(ress => {
                        // let allDevice = this.getFilterMenu(_.cloneDeep(ress.payload))
                        if(ress && ress.payload){
                            this.formatDeviceList(ress.payload)
                        }
                        
                        // console.log("未处理之前数据",ress.payload);
                        // console.log(this.getFilterMenu(ress.payload), this.equipmentUserFilter, this
                        //     .filterMenu(this.getFilterMenu(ress.payload), this.equipmentUserFilter,
                        //         false), this.filterMenu(this.getFilterMenu(ress.payload), this
                        //         .diagnosisIdList, false), this.filterMenu(this.filterMenu(this
                        //             .getFilterMenu(ress.payload), this.diagnosisIdList, false), this
                        //         .normalFaultIdList, true))

                        // this.devices = this.equipmentInfo.length > 0 ? this.filterMenu(this.filterMenu(
                        //         allDevice, this.equipmentUserFilter, false), this.diagnosisIdList,
                        //     true) : []
                        // this.devices.map(item => {
                        //     item['isNormal'] = false
                        //     if (item.children && item.children.length > 0) {
                        //         item.children = []
                        //     }
                        //     item['score'] = 0
                        //     /* 2表示机组设备展示名称*/
                        //     if (item.product_type == 1) {
                        //         item.name = "-"
                        //     }
                        //     item['submitted'] = false
                        // })
                        this.formatDiagnosisDeviceList(ress.payload)

                        // this.serviceSuggestionDevices = this.filterMenu(this.filterMenu(allDevice, this
                        //     .diagnosisIdList, false), this.normalFaultIdList, true)
                        this.formatSuggestionDeviceList(ress.payload)

                        this.measuringPointTableData.map(item => {
                            this.devices.map(b => {
                                if (b.id == item.device.did) {
                                    this.pointTypeList.map(a => {
                                        if (item.device.data[a]['s'] == '3' ||
                                            item.device.data[a]['s'] == '2') {
                                            b['isNormal'] = true
                                        }
                                    })
                                }
                            })
                        })
                        // this.serviceSuggestionDevices.forEach(item => {
                        //     /* 2表示机组设备展示名称*/
                        //     if (item.product_type == 1) {
                        //         item.name = "-"
                        //     }
                        // })


                        this.knowledgeBase = [];
                        this.knowledgeBaseSolution = [];
                    }).catch(err => {
                        console.log(err)
                    })
                })

            },

            callback(row) {
                let str = ''
                this.tabOptions.map(item => {
                    if (this.checkTabValDec == item.id) {
                        str = item.contact_name
                    }
                })

                return row.device_contact === str
            },
            scopeUsers(scope, obj) {
                scope.row.device_contact = obj.label
            },
            //设备信息添加
            setPostAuditingDevice(item) {
                let params = {
                    order: this.$route.params.id,
                    detail: this.checkTabValDec,
                    device: item.id,
                    device_info: JSON.stringify(item)
                }
                postAuditingDevice(params).then(res => {
                    console.log(res)
                    this.$emit('refresh')
                    this.getAuditingDetails()
                    this.getCustomerContacts()
                    this.getModelLists()
                })
            },
            /* 保存设备列表 */ 
            saveDeviceList() {
                // this.deviceListCheckList.map(item => {
                //     this.setPostAuditingDevice(item)
                // })
                // this.toggleValue()
                let callbackList = [];

                this.deviceChangeList.map(item => {
                    callbackList.push(new Promise((resolve, reject) => {
                        instanceAttribute(item.id, item.data).then(res => {
                            console.log(res)
                            return resolve({});
                        }).catch((err) => {
                            console.log(err);
                            return reject(err);
                        });
                    }))
                })

                // let a = 1
                // if(a == 1) return;
                Promise.allSettled(callbackList).then((res) => {
                    console.log(res)
                    for (var resitem of res) {
                        if (resitem.status == 'rejected') {
                            errorMsg(resitem.value)
                            return
                        }
                    }
                    callbackList = []
                    this.deviceChangeList.map(item => {
                        if (item.data.value.length > 0) {
                            let tparams = {
                                order: this.$route.params.id,
                                detail: this.checkTabValDec, /* 问题关键，联系人 */
                                device: item.id,
                                device_info: JSON.stringify(item.item),
                                product_type: item.item.product_type
                            }

                            if (item.item.product_type == '2' || (item.item.product_type == '1' && item
                                    .item.parentId == '')) {
                                tparams["parent_id"] = null
                            } else {
                                tparams["parent_id"] = item.item.parentId
                            }
                            callbackList.push(new Promise((resolve, reject) => {
                                postAuditingDevice(tparams).then(res => {
                                    console.log(res)
                                    return resolve({});
                                }).catch((err) => {
                                    console.log(err);
                                    return reject(err);
                                });
                            }))
                        }
                    })
                    Promise.allSettled(callbackList).then((res1) => {
                        console.log(res1)
                        for (var resitem of res1) {
                            if (resitem.status == 'rejected') {
                                errorMsg(resitem.value)
                                return
                            }
                        }
                        callbackList = []
                        this.deviceChangeList = []
                        this.toggleValue()
                        this.$emit('refresh')
                        this.getAuditingDetails()
                        this.getCustomerContacts()
                        this.getModelLists()
                    })
                })
            },
            //测点列表
            getAuditingDeviceMeasurements() {
                this.measuringPointTableData = []
                let params = {
                    detail_id: this.checkTabValDec
                }
                getAuditingDeviceMeasurement(params).then(res => {
                    this.equipmentInfo.map(item => {
                        /*  填写测点页面，仅获取该联系人下“在用”的设备状态数据 */
                        if ((item.detail == this.checkTabValDec) && (item.device_attributes && item
                                .device_attributes.device_status == '在用') && item.product_type == 1) {
                            /* 机组名称：product_type， 1非机组 2机组 */
                            this.measuringPointTableData.push({
                                group_type: item.parent_device_name || '-', //机组名称
                                device_name: item.device_name,
                                location: item.device_attributes && item.device_attributes
                                    .device_address,
                                device: {
                                    "odid": item.id,
                                    "did": item.device && item.device,
                                    "data": {
                                        "入口压力": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'kpa'
                                        },
                                        "出口压力": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'kpa'

                                        },
                                        "工作液温度": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": '°C'

                                        },
                                        "电流": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'A'

                                        },
                                        "电机轴承温度": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": '°C'

                                        },
                                        "电机轴承振动": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'mm/s'

                                        },
                                        "泵驱动端轴承温度": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": '°C'

                                        },
                                        "泵非驱动端轴承温度": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": '°C'

                                        },
                                        "泵驱动端轴承水平振动": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'mm/s'
                                        },
                                        "泵驱动端轴承垂直振动": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'mm/s'

                                        },
                                        "泵非驱动端轴承水平振动": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'mm/s'

                                        },
                                        "泵非驱动端轴承垂直振动": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'mm/s'

                                        },
                                        "泵非驱动端轴承轴向振动": {
                                            "v": "N/A",
                                            "s": "1",
                                            "u": 'mm/s'

                                        }
                                    }
                                },
                            })
                        }
                    })

                    this.$nextTick(() => {
                        if (res.payload.length > 0) {
                            _.cloneDeep(res.payload).map(item => {
                                this.measuringPointTableData.map(a => {
                                    if (a.device.odid == item.odid) {
                                        a.device = item
                                    }
                                })
                            })
                        }
                    })

                })
            },
            //诊断记录
            getAuditingDiagnosis() {
                this.faultManifestation = []
                if (this.checkTabValDec) {
                    let params = {
                        order_id: this.$route.params.id,
                        detail_id: this.checkTabValDec
                    }
                    getAuditingDiagnosis(params).then(res => {
                        let resData = _.cloneDeep(res.payload)
                        if ((resData.normal && resData.normal.length > 0) || (resData.fault && resData.fault
                                .length > 0)) {
                            this.approvals1 = true
                        }
                        this.normalList = resData.normal
                        
                        this.diagnosisIdList = resData.device_ids
                        this.faultList = resData.fault
                        this.getInstanceApis()
                    })
                }
            },
            //故障一级列表
            getFaultKnowledgeBases(type) {
                this.knowledgeBase = []
                let params = {
                    page_size: 0,
                    device_type: type
                }
                getFaultKnowledgeBase(params).then(res => {
                    console.log(res)
                    if (res.payload && res.payload.length > 0) {
                        this.knowledgeBase = _.cloneDeep(res.payload)
                        this.knowledgeBase.map(item => {
                            item['label'] = item.fault_name
                            item['value'] = item.id
                        })
                    }

                })
            },
            //故障二级列表
            getFaultKnowledgeBaseSolutions(obj, e) {
                obj.fault_name = e
                this.knowledgeBase.map(item => {
                    if (item.id == e) {
                        obj.fault_desc = item.fault_desc
                        obj.fault_name = item.fault_name

                    }
                })
                let params = {
                    fault_knowledge_base: e,
                    page_size: 0
                }
                getFaultKnowledgeBaseSolution(params).then(res => {
                    if (res.payload && res.payload.length > 0) {
                        this.knowledgeBaseSolution = _.cloneDeep(res.payload)
                        this.knowledgeBaseSolution.map(item => {
                            item['label'] = item.fault_reason
                            item['value'] = item.id
                        })

                    }
                })
            },
            faultKnowledgeBaseSolutionsChange(obj, e) {
                obj.fault_reason = e
                this.knowledgeBaseSolution.map(item => {
                    if (item.id == e) {
                        obj.fault_reason = item.label
                        obj.fault_impact = item.fault_impact
                        obj.solution = item.solution
                    }
                })

            },
            //服务建议
            getAuditingServices() {
                let params = {
                    order_id: this.$route.params.id,
                    detail_id: this.checkTabValDec
                }
                getAuditingService(params).then(res => {
                    if (res.payload && res.payload.data) {
                        let resData = _.cloneDeep(res.payload)
                        //  if((resData.data['1']&&resData.data['1'].length>0)||(resData.data['2']&&resData.data['2'].length>0)||(resData.data['3']&&resData.data['3'].length>0)){
                        //    this.approvals2=true
                        //  }
                        this.normalFaultIdList = resData.device_ids
                        this.maintenanceSuggestionTable = resData.data['1'] && resData.data['1'] || [] // 保养
                        this.sparePartsList = resData.data['2'] && resData.data['2'] || [] // 备件
                        this.upgradingList = resData.data['3'] && resData.data['3'] || [] // 技改
                        this.careList = resData.data['4'] && resData.data['4'] || [] // Care
                        this.weixiuList = resData.data['5'] && resData.data['5'] || [] // 维修
                        this.tihuanList = resData.data['6'] && resData.data['6'] || [] // 替换
                    }
                })
            },
            //维修包一级列表
            getRepairKits() {
                let params = {
                    page_size: 0
                }
                getRepairKit(params).then(res => {

                    this.attachmentList = _.cloneDeep(res.payload)

                    this.attachmentList = this.attachmentList.filter((item, index) =>
                        this.attachmentList.findIndex(i => i.device_type === item.device_type) === index);
                    this.attachmentList.map(item => {
                        item['label'] = item.device_type
                        item['value'] = item.device_type
                    })
                })
            },
            //维修包二级列表
            getRepairKitComponents(item, e) {
                if (!e) {
                    errorMsg(this.$t("page.auditing['请优先选择配件类型']"))
                    return
                }
                let params = {
                    device_type: e,
                    repair_kit_type: item.attachment.attachmentLevel,
                    page_size: 0
                }
                getRepairKitComponent(params).then(res => {
                    item.attachment.partsList = _.cloneDeep(res.payload)
                })
            },
            /* 商机转换列表 */
            getAuditingConverts() {
                this.businessOpportunityConversion = []
                this.businessOpportunityConversionAmount = 0
                let params = {
                    order_id: this.$route.params.id,
                    detail_id: this.checkTabValDec
                }

                getAuditingConvert(params).then(res => {

                    if ((res.payload && res.payload.length > 0)) {
                        this.approvals3 = true
                        this.businessOpportunityConversion = _.cloneDeep(res.payload)

                    }
                    if (this.businessOpportunityConversion.length > 0) {
                        this.businessOpportunityConversion.map(item => {
                            this.businessOpportunityConversionAmount += Number(item.amount)
                        })
                    }
                })
            },
            /* 保存商机 */ 
            postAuditingConverts() {
                let params = this.businessOpportunityConversion
                params.map(item => {
                    item['order_id'] = this.$route.params.id
                    item['detail_id'] = this.checkTabValDec
                })
                postAuditingConvert(params).then(res => {
                    console.log(res)
                    this.getAuditingConverts()
                }).catch(() => {
                    ElMessage({
                        type: "error",
                        message: this.$t("page.auditing['只能输入整数']")
                    });

                })

            },
            /* 操作商机转换 */ 
            handleEditBusiness(item){
                this.modalTitle = '商机转换'
                this.userModal = true
                this.businessFormModel = {...item}
                var that = this;
                setTimeout(function () {
                    that.$refs['ruleFormRefBusiness'].clearValidate();//消除校验,这里的setTimeOut不能去掉,去掉之后会不生效
                },100);
            },

            inputAmountStage(e){
                let info = this.businessStage.find(item=>item.value == e)
                if(info){
                    this.businessFormModel.possibility = info.possibility
                }
            },
            tabsChange(name) {
                this.tabOptions.map(item => {
                    if (item.id === name) {
                        this.checkTabContact = item.contact
                        // ('1','执行中'), ('2','待审核'), ('3','待签字'), ('4','已完成')
                        this.$emit('tabStatusChange', item.status)

                    }
                })
                this.getAuditingDetails()
                this.getCustomerContacts()
                this.getModelLists()
                this.getAuditingDiagnosis()
            },
            //表格选择
            handleSelectionChange(val, e) {
                switch (val) {
                    case 'deviceList':
                        this.deviceListCheckList = e
                        break;
                    case 'devices':
                        this.devicesCheckList = e
                        this.diagnosticMeasuringPoint = []
                        this.measuringPointTableData.map(item => {
                            this.devicesCheckList.map(b => {
                                if (b.id == item.device.did) {
                                    this.pointTypeList.map(a => {
                                        if (item.device.data[a]['s'] == '3' || item.device.data[
                                                a]['s'] == '2') {
                                            this.diagnosticMeasuringPoint.push({
                                                device: item.device.did,
                                                device_location: item.location,
                                                key: a,
                                                value: item.device.data[a]['v']
                                            })

                                        }
                                    })
                                }
                            })
                        })

                        break;
                    case 'diagnosticMeasuringPoint':
                        this.diagnosticMeasuringPointCheckList = e
                        break;
                    case 'serviceSuggestionDevices':
                        this.serviceSuggestionDevicesCheckList = e
                        break;
                    default:
                        break;

                }
                //
            },
            /* 设置分页选项 */
            setPages() {
                this.pages = [];
                this.tab_info_length = this.count;
                let numberOfPages = Math.ceil(this.count / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {
                    this.pages.push(index);
                }
            },
            // 翻页
            pageChange(val) {
                this.filters.page = val;
                this._getList();
            },
            // 设置每页条数
            pageSizeChange(val) {
                this.filters.page_size = val;
                this._getFirstPage();
            },
            // 获取数据
            _getFirstPage() {
                this.page = 1;
                this.filters.page = 1;
                this._getList();
            },
            formatDatetime,
            deviceInfo(root_sn) {
                getDeviceInfo(root_sn, true, true).then(res => {
                    this.device = res
                    this.deviceImgs = _.get(res, 'files.image', [])
                    this.setQRcodeUrl(res.attributes, res.extra_info)
                    this.$emit('deviceLoaded', res)
                })
            },
            getField(name) {
                return _.get(this.device, name, '')
            },
            //生成二维码
            setQRcodeUrl(attributes, extra_info) {
                let qrcodeCheckedList = extra_info.qrcodeCheckedList;
                let codes = "";
                attributes.map((attr) => {
                    if (
                        attr.group === this.$t('page.work-order.device.equipment_delivery_information') &&
                        (!qrcodeCheckedList || qrcodeCheckedList.includes(attr.id))
                    ) {
                        let unit = attr.unit == this.$t('page.no') ? "" : attr.unit;
                        codes += `${attr.name}:${attr.value} ${unit};`;
                    }
                });
                this.qrCodeValue = codes;
            },
            modalChange(val) {
                if (val === '设备测点' || val === '诊断记录') {
                    this.getAuditingDeviceMeasurements()
                }
                this.modalTitle = val;
                this.knowledgeBase = [];
                this.knowledgeBaseSolution = [];
                this.files = {
                    image: [],
                    video: [],
                    document: []
                };
                this.filesNums = [];
                this.faultName = '';
                this.faultManifestation = [];
                this.deviceListCheckList = [];
                this.devicesCheckList = [];
                this.diagnosticMeasuringPoint = [];
                this.contactPerson = '';
                this.devicesType = null;
                this.serviceType = null;
                this.diagnosticMeasuringPointCheckList = [];
                this.serviceSuggestionDevicesCheckList = [];
                this.faultEditableTabsValue = '1';
                this.faultEditableTabs = [{
                    title: '故障',
                    name: '1',
                    fault_knowledge_base_id: '',
                    fault_desc: '',
                    fault_name: '',
                    files: [],
                    filesList: {
                        image: [],
                        video: [],
                        document: []
                    },
                    solutions: [{
                        fault_knowledge_base_solution_id: '',
                        fault_reason: '',
                        fault_impact: '',
                        solution: '',
                    }]
                }];
                this.suggestionEditableTabsValue = '1';
                this.suggestionEditableTabs = [{
                    title: '建议',
                    name: '1',
                    content: 'Tab 1 content',
                    type: '',
                    maintain: {
                        suggestionType: '',
                        suggestionList: []
                    },
                    attachment: {
                        attachmentType: '',
                        attachmentLevel: '',
                        attachmentNum: '',
                        partsList: []
                    },
                    technicalReform: {
                        technicalReformModel: '',
                        desc: ''
                    },
                    care: {
                        careModel: '',
                        desc: ''
                    },
                    other: {
                        desc: ''
                    }
                }];
                if (this.$refs.xTable) {
                    this.$refs.xTable.clearSelection();
                }
                if (this.$refs.dTable) {
                    this.$refs.dTable.clearSelection();
                }
                if (this.$refs.sTable) {
                    this.$refs.sTable.clearSelection();
                }
                this.getAuditingDiagnosis();
                this.$nextTick(() => {
                    this.userModal = true
                })
            },
            saveChanges(val, e) {
                console.log(val, e)
            },
            handleTabsEdit(targetName, action) {
                if (action === 'add') {
                    let newTabName = ++this.tabIndex + '';
                    this.faultEditableTabs.push({
                        title: '故障',
                        name: newTabName,
                        fault_name: '',
                        fault_knowledge_base_id: '',
                        fault_desc: '',
                        files: [],
                        filesList: {
                            image: [],
                            video: [],
                            document: []
                        },
                        solutions: [{
                            fault_knowledge_base_solution_id: '',
                            fault_reason: '',
                            fault_impact: '',
                            solution: '',
                        }]
                    });
                    this.faultEditableTabsValue = newTabName;
                }
                if (action === 'remove') {
                    alertComfirm(this.$t('Confirm to perform this operation?'), `${this.$t('base.delete')}${this.$t('Failure')}`)
                    .then(res => {
                        if (res) {
                            let tabs = this.faultEditableTabs;
                            let activeName = this.faultEditableTabsValue;
                            if (activeName === targetName) {
                                tabs.forEach((tab, index) => {
                                    if (tab.name === targetName) {
                                        let nextTab = tabs[index + 1] || tabs[index - 1];
                                        if (nextTab) {
                                            activeName = nextTab.name;
                                        }
                                    }
                                });
                            }

                            this.faultEditableTabsValue = activeName;
                            this.faultEditableTabs = tabs.filter(tab => tab.name !== targetName);
                        }
                    })

                }
            },
            handleTabsSuggestionEdit(targetName, action) {
                if (action === 'add') {
                    let newTabName = ++this.suggestiontabIndex + '';
                    this.suggestionEditableTabs.push({
                        title: '建议',
                        name: newTabName,
                        content: 'New Tab content',
                        type: '',
                        maintain: {
                            suggestionType: '',
                            suggestionList: []
                        },
                        attachment: {
                            attachmentType: '',
                            attachmentLevel: '',
                            attachmentNum: '',
                            partsList: []
                        },
                        technicalReform: {
                            technicalReformModel: '',
                            desc: ''
                        },
                        care: {
                            careModel: '',
                            desc: ''
                        },
                        other: {
                            desc: ''
                        }
                    });
                    this.suggestionEditableTabsValue = newTabName;
                }
                if (action === 'remove') {
                    alertComfirm(this.$t('Confirm to perform this operation?'),`${this.$t('base.delete')}${this.$t('page.auditing.suggestions')}`)
                    .then(res => {
                        if (res) {
                            let tabs = this.suggestionEditableTabs;
                            let activeName = this.suggestionEditableTabsValue;
                            if (activeName === targetName) {
                                tabs.forEach((tab, index) => {
                                    if (tab.name === targetName) {
                                        let nextTab = tabs[index + 1] || tabs[index - 1];
                                        if (nextTab) {
                                            activeName = nextTab.name;
                                        }
                                    }
                                });
                            }

                            this.suggestionEditableTabsValue = activeName;
                            this.suggestionEditableTabs = tabs.filter(tab => tab.name !== targetName);
                        }
                    })

                }
            },
            //增加故障原因
            addFault(item) {
                item.solutions.push({
                    fault_knowledge_base_solution_id: '',
                    fault_reason: '',
                    fault_impact: '',
                    solution: ''
                })

            },
            removeFault(index, item) {
                item.splice(index, 1)
            },
            maintenanceSuggestionChange(item) {
                if (this.maintenanceSuggestion.length > 0) {
                    this.maintenanceSuggestionList[item.maintain.suggestionType].push({
                        value: this.maintenanceSuggestion,
                        label: this.maintenanceSuggestion
                    })
                    this.maintenanceSuggestion = ''
                }
            },
            saveForm() {

                let params = []
                let flag = true
                switch (this.modalTitle) {
                    case "联系人":
                        this.userOptions.map(item => {
                            if (this.contactPerson == item.id) {
                                let params = {
                                    order: this.$route.params.id,
                                    contact: item.id,
                                    service_company: this.user.org.id,
                                    owner_engineer: this.user.id
                                }
                                postAuditingDetail(params).then(res => {
                                    this.checkTabValDec = _.cloneDeep(res.payload).id
                                    this.checkTabContact = _.cloneDeep(res.payload).contact
                                    this.userModal = false
                                    this.$nextTick(() => {
                                        this.getAuditingDetails();
                                        this.getCustomerContacts();
                                        this.getInstanceApis();
                                        this.getAuditingServices()
                                        this.getAuditingDiagnosis()
                                    })

                                })
                            }
                        })
                        break;
                    case "设备列表":
                        this.saveDeviceList()

                        break;
                    case "设备测点":{
                        let pass = true;
                        this.measuringPointTableData.map(item => {
                            let obj = item.device.data
                            for( let key in obj ){
                               if(obj[key].s !== '1'&& (obj[key].v === 'N/A'||String(obj[key].v) == '')) {
                                    pass = false
                                    return; 
                               }
                            }
                            params.push(item.device)
                        })

                        if(pass) {
                            this.$nextTick(() => {
                                postAuditingDeviceMeasurement(params).then(res => {
                                    console.log(res)
                                    this.$nextTick(() => {
                                        this.getAuditingDetails();
                                        this.getCustomerContacts();
                                        this.getInstanceApis();
                                        this.getAuditingServices()
                                        this.getAuditingDiagnosis()
                                        this.toggleValue()
                                    })

                                })
                            })
                        }else{
                            ElMessage({
                                type: "error",
                                message: this.$t("page.auditing['请完善设备测点']")
                            });
                        }


                    }
                        break;
                    case "诊断记录":
                        if (this.devicesCheckList.length === 0) {
                            errorMsg(this.$t("page.auditing['请选择设备']"))
                            flag = false
                        }
                        params = {
                            order_id: this.$route.params.id,
                            detail_id: this.checkTabValDec,
                            is_fault: !this.faultType,
                            devices: [],
                            measurements: this.diagnosticMeasuringPointCheckList,
                            faults: _.cloneDeep(this.faultEditableTabs),
                        }
                        
                        params.faults && params.faults.map((item, index) => {
                            if (typeof item.fault_knowledge_base_id === "string") {
                                item.fault_name = item.fault_knowledge_base_id
                                item.fault_knowledge_base_id = ''
                                if (item.fault_name.length === 0 && !this.faultType) {
                                    //中英文切换
                                    const lang = getLanguage()
                                    let msg = `${this.$t("page.auditing['请填写故障的故障名称']")} ${index + 1}!`
                                    if( lang == 'ch' ){ /* 中文 */
                                        msg = '请填写故障' + (index + 1) + '故障名称!'
                                    }
                                    errorMsg(msg)
                                    flag = false
                                }
                            }
                            item.solutions && item.solutions.map((s, i) => {
                                if (typeof s.fault_knowledge_base_solution_id === "string") {
                                    s.fault_reason = s.fault_knowledge_base_solution_id
                                    s.fault_knowledge_base_solution_id = ''
                                    if (item.fault_reason && item.fault_reason.length === 0 && !this
                                        .faultType) {
                                        //中英文切换
                                        const lang = getLanguage()
                                        let msg = `${this.$t("page.auditing['请填写初步分析原因']")} ${index + 1}!`
                                        if( lang == 'ch' ){ /* 中文 */
                                            msg = '请填写初步分析原因' + (i + 1) + '!'
                                        }
                                        errorMsg(msg)
                                        flag = false
                                    }
                                }
                            })
                        })
                        this.devices.map(a => {
                            a.submitted = false
                            this.devicesCheckList.map(item => {
                                if (a.id === item.id) {
                                    if (item.score > 0 || item.product_type == '2') {
                                        params.devices.push({
                                            id: item.id,
                                            info: item,
                                            score: item.score
                                        })
                                    } else {
                                        a.submitted = true
                                        errorMsg(this.$t("page.auditing['请对设备做出体检评分']"))
                                        flag = false

                                    }

                                }
                            })
                        })
                        if (flag) {
                            postAuditingDiagnosis(params).then(res => {
                                console.log(res)
                                this.$nextTick(() => {
                                    this.getAuditingDetails();
                                    this.getCustomerContacts();
                                    this.getInstanceApis();
                                    this.getAuditingServices()
                                    this.getAuditingDiagnosis()
                                    this.toggleValue()
                                })
                            })
                        }
                        break;
                    case "服务建议":{
                        
                        params = {
                            order_id: this.$route.params.id,
                            detail_id: this.checkTabValDec,
                            fault_name: this.faultName,
                            devices: [],
                            services: [],
                        }
                        this.suggestionEditableTabs.map(item => {
                            switch (item.type) {
                                case '1':
                                    params.services.push({
                                        type: item.type,
                                        remark: '',
                                        data: item.maintain
                                    })
                                    break;
                                case '2':
                                    params.services.push({
                                        type: item.type,
                                        remark: item.attachment.desc,
                                        data: item.attachment
                                    })

                                    break;
                                case '3':
                                    params.services.push({
                                        type: item.type,
                                        remark: item.technicalReform.desc,
                                        data: item.technicalReform
                                    })
                                    break;
                                case '4':
                                    params.services.push({
                                        type: item.type,
                                        remark: item.care.desc,
                                        data: item.care
                                    })
                                    break;
                                default:
                                    /* 规避是否选择建议类型 */
                                    if(item.type) {
                                        params.services.push({
                                            type: item.type,
                                            remark: item.other.desc,
                                            data: item.other
                                        })
                                    }
                                    break;
                            }

                        })
                        this.serviceSuggestionDevicesCheckList.map(item => {
                            params.devices.push({
                                id: item.id,
                                info: item,
                                score: item.score
                            })
                        })
                       
                        /* 校验设备是否勾选 */ 
                        if (params.devices.length === 0) {
                            errorMsg(this.$t("page.auditing['请选择设备']"))
                            this.flag = false
                            return;
                        } else {
                            this.flag = true
                        }
                        
                         /* 建议类型不能为空 */ 
                        if(params.services.length === 0){
                            errorMsg(this.$t("page.auditing['请选择建议类型']"))
                            return;
                        }

                        

                        params.services.map(item => {

                            switch (item.type) {
                                case '1':
                                    if (item.data.suggestionList.length === 0 || item.data.suggestionType
                                        .length === 0) {
                                        errorMsg(this.$t("page.auditing['请填写维保类型和维保项目']"))
                                        this.flag = false
                                    } else {
                                        this.flag = true
                                    }

                                    break;
                                case '2':
                                    if (item.data.attachmentLevel.length === 0 || item.data.attachmentType
                                        .length === 0) {
                                        errorMsg(this.$t("page.auditing['请填写配件类型']"))
                                        this.flag = false

                                    } else {
                                        this.flag = true
                                    }
                                    break;
                                case '3':
                                    if (item.data.technicalReformModel.length === 0) {
                                        errorMsg(this.$t("page.auditing['请填写设备型号']"))
                                        this.flag = false
                                    } else {
                                        this.flag = true
                                    }
                                    break;
                                case '4':
                                    if (item.data.careModel.length === 0) {
                                        errorMsg(this.$t("page.auditing['请填写Care类型']"))
                                        this.flag = false
                                    } else {
                                        this.flag = true
                                    }
                                    break;
                                default:
                                    break;
                            }
                        })
                        if (this.flag) {
                            this.toggleValue()
                            postAuditingService(params).then(res => {
                                console.log(res)
                                this.$nextTick(() => {
                                    this.getAuditingDetails();
                                    this.getCustomerContacts();
                                    this.getInstanceApis();
                                    this.getAuditingServices()
                                })
                            })
                        }
                    }

                        break;
                    case "商机转换":{  
                        this.$refs['ruleFormRefBusiness'].validate((valid, fields) => {
                            if (!valid) {
                                console.log('error submit!', fields)
                                return
                            }
                             console.log('submit!')
                             this.businessFormModel.possibility = String(this.businessFormModel.possibility)
                            let params = {
                                ...this.businessFormModel,
                                order_id: this.$route.params.id,
                                detail_id: this.checkTabValDec
                            }
                            postAuditingConvert(params).then(res => {
                                console.log(res)
                                successMsg(this.$t('base.operate_success'))
                                this.getAuditingConverts()
                                this.userModal = false

                            }).catch((err) => {
                                ElMessage({
                                    type: "error",
                                    message: err.message
                                });
    
                            })

                        })  
                    }
                    break;
                    default:
                        this.$nextTick(() => {
                            this.getAuditingDetails();
                            this.getCustomerContacts();
                            this.getInstanceApis();
                            this.toggleValue()
                        })
                        break;
                }

            },
            handleTabsUserEdit(targetName, action) {

                if (action === 'add') {
                    this.modalTitle = '联系人'
                    this.userModal = true
                }
                if (action === 'remove') {
                    alertComfirm(this.$t('Confirm to perform this operation?'),this.$t("page.auditing['删除联系人']"))
                    .then(res => {
                        if (res) {
                            deleteAuditingDetail(targetName).then(() => {
                                this.getAuditingDetails('first')
                                this.getCustomerContacts()
                                successMsg(this.$t('base.operate_success'))
                            })
                        }
                    })

                }
            },
            clearInstanceAttribute(row){
                if(row.children){
                    row.children.forEach(item=>{
                        item.device_contact = ''
                    }) 
                }
            },
            setInstanceAttribute(row) {
                // let params = {
                //     name: '设备联系人',
                //     value: row.device_contact
                // }
                // instanceAttribute(row.id, params).then(res => {
                //     console.log(res)
                //     // this.getInstanceApis()

                //     this.tabOptions.map(item => {
                //         if (row.device_contact === item.contact_name) {
                //             this.toggleSelection([row])
                //             this.deviceListCheckList = this.$refs.xTable.getSelectionRows()
                //         }
                //     })
                // })
                let paramsList = []
                /* 匹配相对应的联系人id */ 
                let contact = this.tabOptions.find(item=>item.contact_name === row.device_contact)
                if(!contact) return;
                let params = {
                    id: row.id,
                    data: {
                        name: '设备联系人',
                        value: row.device_contact,
                        id:contact.id
                    },
                    item: row
                }
                paramsList.push(params)
                const children = row.children || []
                for (var subitem of children) {
                    /* 匹配相对应的联系人id */ 
                    let contact1 = this.tabOptions.find(item=>item.contact_name === row.device_contact)
                    let params = {
                        id: subitem.id,
                        data: {
                            name: '设备联系人',
                            value: row.device_contact,
                            id:contact1.id
                        },
                        item: subitem
                    }
                    subitem.device_contact = row.device_contact
                    paramsList.push(params)
                }
                for (var item1 of paramsList) {
                    let tfilter = _.filter(this.deviceChangeList, function(o) {
                        return item1.id == o.id;
                    });

                    if (tfilter.length == 0) {
                        this.deviceChangeList.push(item1)
                    } else {
                        for (var item2 of this.deviceChangeList) {
                            if (item2.id == item1.id) {
                                item2.data = item1.data
                            }
                        }
                    }
                }

                const temp = false
                if (temp) {
                    let callbackList = [];
                    for (var paramsItem of paramsList) {
                        callbackList.push(new Promise((resolve, reject) => {
                            instanceAttribute(paramsItem.id, paramsItem.data).then(res => {
                                console.log(res)
                                const result = {
                                    id: paramsItem.id,
                                    code: 1,
                                    item: paramsItem.item
                                }
                                return resolve(result);
                            }).catch((err) => {
                                console.log(err);
                                const result = {
                                    id: paramsItem.id,
                                    code: 0,
                                    item: paramsItem.item
                                }
                                return reject(result);
                            });
                        }))
                    }
                    Promise.allSettled(callbackList).then((res) => {
                        console.log(res)
                    })
                }
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.xTable.toggleRowSelection(row)
                        if (row.children && row.children.length > 0) {
                            row.children.map(item => {
                                this.$refs.xTable.toggleRowSelection(item, false)
                            })
                        }
                    })

                }
            },
            //删除诊断
            deleteDiagnosticPoint(item) {

                deleteAuditingDiagnosis(item.id).then(res => {
                    console.log(res)
                    successMsg(this.$t('base.operate_success'))
                    this.getAuditingDiagnosis()
                    this.getAuditingServices()
                    this.getInstanceApis()
                })
            },
            //删除服务建议
            deleteServicePoint(item) {
                deleteAuditingService(item.id).then(res => {
                    console.log(res)
                    successMsg(this.$t('base.operate_success'))
                    this.getAuditingServices()
                    this.getInstanceApis()
                })
            },
            //签到
            signIn() {
                // 可通过url showSignIn=true 来绕过，方便用于测试！！！
                if (!this.$route.query.showSignIn) return ElMessage({
                    message: '请在小程序上完成签到',
                    type: 'warning',
                })

                let params = {
                    order: this.$route.params.id,
                    detail: this.checkTabValDec,
                    check_in_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                    address: '重庆科技金融中心',
                    latitude: '29.583287443328903',
                    longitude: '106.56716771713256'
                }
                auditingCheckin(params).then(res => {
                    console.log(res)
                    successMsg('签到成功')
                    this.getAuditingDetails()
                    this.$emit('refresh')

                })
            },
            /* 限制0-100 成单可行性*/ 
            roleInput(value){
                if(value){
                    this.businessFormModel.possibility= String(value).replace(/[^\d.]/g,'')
                    if(Number(value)<=0){
                        this.businessFormModel.possibility=0 
                    }
                    if( Number(value) > 100 ){
                        this.businessFormModel.possibility=100
                    }
                } 
            },
            roleInputScore(item,event){
                let value = event.target.value
                if(value){
                    item.score= String(value).replace(/[^\d.]/g,'')
                    if(Number(value)<=0){
                        item.score=0 
                    }
                    if( Number(value) > 100 ){
                        item.score=100
                    }
                }
            },
            // 验证规则
            getRules() {
                let rules = {
                    type: [
                        { required: true, message: this.$t('base.required'), trigger: 'change' },
                    ],
                    stage: [
                        { required: true, message: this.$t('base.required'), trigger: 'change' },
                    ],
                    amount: [
                        { required: true, message: this.$t('base.required'), trigger: 'change' },
                    ],
                    possibility: [
                        { required: true, message: this.$t('base.required'), trigger: 'change' },
                    ],
                }
                return rules
            },
            /* 判断联系人tab，是否可以删除，按钮的显隐 */ 
            isClosable(status){
                let isShow = false
                //有点判断用户的角色状态
                if(this.user.user_type != 'customer' && status < 3){
                    isShow = true
                }
                return isShow;   
            }
        },
        components: {
            SwiperTool,
            Database,
            // Plus,
            Attr,
            Attr1,
            // WoStatusEtc
            // Swiper,
            // SwiperSlide,
            // vueQr,
            addUpdateAccountDialog
        },
        computed: {
            /* 未诊断的设备数量 */ 
            undiagnosedDeviceNum(){
                return this.equipmentInfo.length>0?(this.equipmentCount-this.diagnosisIdList.length):0;
            },
            /* 未服务的设备数量  */ 
            unservicedDeviceNum(){
                return this.diagnosisIdList.length- this.normalFaultIdList.length;
            },
            API_SVC_HOST() {
                return API_SVC_HOST
            },
            user() {
                return JSON.parse(localStorage.getItem("user"));
            },
            permission() {
                return JSON.parse(localStorage.getItem("permission"));
            },
            // 是否显示提交审批按钮
            showPostApproveBtn() {
                // 有技术人员或者销售人员的权限
                return this.permission.includes('auditing.role.technical') || this.permission.includes(
                    'auditing.role.sale')
            },
            // 是否有销售服务工程师权限
            hasSaleRolePermission() {
                return this.permission.includes('auditing.role.sale')
            },
            canEditableTab() {
                // this.woData.status 工单状态：'1':'待施工','2':'施工中','3':'已完成','4':'已取消'
                // this.tabStatus ('1','执行中'), ('2','待审核'), ('3','待签字'), ('4','已完成')

                // 工单状态：'1':'待施工','2':'施工中','3':'已完成','4':'已取消'
                // 只有'待施工'的可以更改
                // ['1'].includes(this.woData.status)

                // '3':'已完成','4':'已取消' 状态的工单不可增删改联系人
                return this.user.user_type !== 'customer' && this.showPostApproveBtn && !['3', '4'].includes(this.woData
                    .status)
            },

            isCustomer() {
                return this.user.user_type === 'customer'
            }

        },
        watch: {
            checkTabValDec(newVal) {
                this.$emit('tabIdChange', newVal)
            },
            faultEditableTabs: {
                immediate: true,
                deep: true,
                handler(val) {
                    this.faultEditFilter = []
                    this.knowledgeBaseSolutionFilter = []
                    val.map(item => {
                        item.solutions.map(v => {
                            this.knowledgeBaseSolutionFilter.push(v.fault_knowledge_base_solution_id)
                        })
                        this.faultEditFilter.push(item.fault_knowledge_base_id)
                    })
                }
            },
            woData: {
                immediate: true,
                deep: true,
                handler(val) {
                    // 根据root_sn获取设备信息
                    if (val.device_root_sn) {
                        this.deviceInfo(this.woData.device_root_sn)
                    } else {
                        this.device = {}
                        this.deviceImgs = []
                    }
                    // 获取维保记录:相同设备的工单，除已取消状态的，不分页
                    if (val.device_root_sn) {
                        workOrderList({
                            device_root_sn: val.device_root_sn,
                            status: '1,2,3',
                            ordering: '-created_at,status',
                            page: 1,
                            page_size: 0
                        }).then(res => {
                            this.dataList = _.cloneDeep(res.payload)
                        })
                    }
                }
            }
        }
    }
</script>
<template>
    <b-row v-show="checkTabVal=='2'">
        <b-col> 
            <div v-if="tabOptions&&tabOptions.length>0 && canEditableTab"
                class="w-100 d-flex justify-content-between mt-2">
                <div class="d-flex align-items-center">
                    <div style="color: #B6B6B6;font-size: 13px;font-weight: 400;line-height: 100%">{{ $t('page.auditing.unallocated_individual_equipment') }}：</div>
                    <div class="d-flex align-items-center">
                        <div
                            style="width:17px;height:17px;border-radius: 4px;background: #ED5E5E;color:#ffffff;text-align: center;line-height: 17px">
                            <!-- {{orderInfo.not_assigned_device&&orderInfo.not_assigned_device.not_assigned}} -->
                            {{notAssigned}}
                        </div>
                        <div style="width: 100px" class="ms-2">
                            <!-- ((((orderInfo.not_assigned_device&&orderInfo.not_assigned_device.count)-(orderInfo.not_assigned_device&&orderInfo.not_assigned_device.not_assigned))/(orderInfo.not_assigned_device&&orderInfo.not_assigned_device.count))*100).toFixed(2)||0 -->
                            <el-progress color="['#DFE3ED','#29c26e']"
                                :percentage="percentageNum" />
                        </div>
                    </div>
                </div>
                <div class="btn-wrap">
                    <button class="btn btn-primary" @click="addContactPerson"><i class="las la-plus"></i>
                        <span>{{ $t('page.auditing.add_contact') }}</span></button>
                    <button class="btn btn-primary" @click="modalChange('联系人')"><i class="ri-user-add-line me-1"></i>
                        <span>{{ $t('page.auditing.selcet_contact') }}</span></button>
                </div>
            </div>
            <!--  isCustomer && 'hideTabRow' -->
            <el-tabs v-model="checkTabValDec" :class="['demo-tabs', 'topTabsButton',]"
                v-if="tabOptions&&tabOptions.length>0" @edit="handleTabsUserEdit" @tabChange="tabsChange">
                <template #addIcon>
                    <div class="position-relative">
                        <div class="btn-wrap" v-if="canEditableTab">
                            <button class="btn btn-primary" @click.stop="addContactPerson"><i class="las la-plus"></i>
                                <span>{{ $t('page.auditing.add_contact') }}</span></button>
                            <button class="btn btn-primary" @click.stop="modalChange('联系人')"><i
                                    class="ri-user-add-line me-1"></i> <span>{{ $t('page.auditing.selcet_contact') }}</span></button>
                        </div>

                        <div class="d-flex align-items-center ms-4 position-absolute" style="top: 10px;left:-240px">
                            <div style="color: #B6B6B6;font-size: 13px;font-weight: 400;line-height: 100%">{{ $t('page.auditing.unallocated_individual_equipment') }}：
                            </div>
                            <div class="d-flex align-items-center">
                                <div
                                    style="width:17px;height:17px;border-radius: 4px;background: #ED5E5E;color:#ffffff;text-align: center;line-height: 17px">
                                    <!-- {{woData.not_assigned_device&&woData.not_assigned_device.not_assigned}} -->
                                    {{notAssigned}}
                                </div>
                                <div style="width: 100px" class="ms-2">
                                    <!-- ((((woData.not_assigned_device&&woData.not_assigned_device.count)-(woData.not_assigned_device&&woData.not_assigned_device.not_assigned))/(woData.not_assigned_device&&woData.not_assigned_device.count))*100).toFixed(2)||0 -->
                                    <el-progress color="['#DFE3ED','#29c26e']"
                                    :percentage="percentageNum"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <el-tab-pane v-for="( item, tabIndex) in tabOptions" :key="item.name" :label="item.title" :name="item.name"
                    :closable="isClosable(item.status)">
                    <!-- 联系人基本信息 -->
                    <b-card>
                        <b-card-header class="fs-14 fw-bold d-flex justify-content-between ps-0 pt-0">
                            <div class="d-flex align-items-center">
                                <div class="d-flex align-items-center">
                                    <img style="width:24px;height:26px;margin-right: 10px"
                                        src="../components/reportimg/lianxiren.svg" alt="#">
                                    <div>{{ $t('page.auditing.Basic Contact Information') }}</div>
                                </div>

                            </div>
                            <div style="width: 370px" class="d-flex justify-content-end">
                                <!-- <button v-if="item.status=='0' && showPostApproveBtn" type="button"
                                    class="ms-2 btn btn-primary" @click="signIn">签到</button> -->
                                <div v-if="!tabOptions[tabIndex].is_checkin">
                                    <i class="ri-information-line ms-1 cursor-pointer text-warning"></i>
                                    {{ $t("page.auditing['请在小程序上签到']")}}
                                </div>
                                <div v-if="!editType" class="d-flex justify-content-end">
                                    <button v-if="(item.status=='2')&&permission.includes('auditing.role.sale')"
                                        class="ms-2 btn btn-danger d-flex align-items-center"
                                        @click="postAuditingReviews('2')">{{ $t('base.refuse') }}</button>
                                    <button v-if="(item.status=='2')&&permission.includes('auditing.role.sale')"
                                        class="ms-2 btn btn-success d-flex align-items-center"
                                        @click="postAuditingReviews('1')">{{$t('base.pass') }}</button>
                                    <button v-if="item.status=='1' && showPostApproveBtn"
                                        class="ms-2 btn btn-info d-flex align-items-center"
                                        @click="postAuditingApprovals">{{ $t('page.auditing.submit_approval')}}</button>
                                </div>
                            </div>
                        </b-card-header>
                        <b-card-body>
                            <div :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(items, index) in tableHeadersContact" :key="index">
                                                <th v-show="items.visible">{{ items.label }}</th>
                                            </template>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr>
                                            <td> {{item.contact_name}} </td>
                                            <td> {{item.contact_tel}} </td>
                                            <td> {{item.contact_email}} </td>
                                            <td>
                                                <div v-if="!editType">{{item.departure_time}}</div>
                                                <el-date-picker style="width:150px" v-else v-model="item.departure_time"
                                                    type="date" placeholder="" format="YYYY-MM-DD"
                                                    value-format="YYYY-MM-DD" @change="contactTime(item)" />
                                            </td>
                                            <td>
                                                <div>{{item.arrival_time}}</div>
                                            </td>
                                            <td>
                                                <div v-if="!editType">{{item.leave_time}}</div>
                                                <el-date-picker style="width:150px" v-else v-model="item.leave_time"
                                                    type="date" placeholder="" format="YYYY-MM-DD"
                                                    value-format="YYYY-MM-DD" @change="contactTime(item)" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </b-card-body>
                    </b-card>

                    <!-- 设备信息 -->
                    <b-card>
                        <b-card-header class="fs-14 fw-bold d-flex justify-content-between ps-0 pt-0">
                            <div class="d-flex align-items-center">
                                <img style="width:24px;height:26px;margin-right: 10px"
                                    src="../components/reportimg/shebeixinxi.svg" alt="#">
                                <div>{{ $t('page.auditing.Equipment Information') }}</div>
                            </div>
                            <!-- v-if="editType"-->
                            <div class="d-flex justify-content-end">
                                <!-- 审核通过之后，无法选择设备 -->
                                <button v-if="isClosable(item.status)"  class="btn btn-primary d-flex align-items-center"
                                    @click="modalChange('设备列表')"><img style="width: 14px;height: 13px;"
                                        src="./selectequipment.svg" alt="#" class="me-1" /> <span>{{ $t('page.auditing.select_equipment') }}</span> </button>
                                <button  v-if="woData.status=='2'&&editType" style="margin-left:10px;"
                                    class="btn btn-primary d-flex align-items-center" @click="modalChange('设备测点')"><img
                                        style="width: 14px;height: 13px;" src="./equipmentpoint.svg" alt="#"
                                        class="me-1" /> <span>{{ $t('page.auditing.measurements') }}</span> </button>
                            </div>
                        </b-card-header>
                        <b-card-body>
                            <div :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="item in tableHeaders" :key="item.label">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-show="!tabOptions[tabIndex].is_checkin || editType">{{ $t('base.operation') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all overflow-auto">
                                        <tr>
                                            <td colspan="100" class="text-center" style="color:#909399;font-size: 14px;"
                                                v-if="equipmentInfo.length === 0">
                                                {{ $t('base.no-data') }}
                                            </td>
                                        </tr>
                                        <tr v-for="(item,index) in equipmentInfo" :key="item.id">
                                            <template
                                                v-if="item.isParent == true || (item.isParent == false && item.isShow == true)">
                                                <!--                      <th scope="row">-->
                                                <!--                        <div class="form-check">-->
                                                <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                                                <!--                        </div>-->
                                                <!--                      </th>-->
                                                <td>
                                                    <div class="d-flex align-items-center"
                                                        v-if="item.device_attributes&&item.device_attributes.product_type=='2'">
                                                        <i v-if="item.isShow"
                                                            class="ri-checkbox-indeterminate-line cursor-pointer fs-16"
                                                            @click="deviceStatusClick(item)"></i>
                                                        <i v-else class="ri-add-box-line cursor-pointer fs-16"
                                                            @click="deviceStatusClick(item)"></i>
                                                        <span style="margin-left: 5px;">{{ item.device_name }}</span>
                                                    </div>
                                                    <template v-else>
                                                        <div v-if="item.isParent" style="padding-left: 20px;">
                                                            <span>{{ item.device_name }}</span>
                                                        </div>
                                                        <div v-else style="padding-left: 40px;">
                                                            <span>{{ item.device_name }}</span>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td>
                                                    <span>{{ (item.device_attributes&&item.device_attributes.product_type=='1')?(item.device_attributes&&item.device_attributes.device_type):'-' }}</span>
                                                </td>
                                                <!-- <td>
                                                    <span>{{ item.device_name }}</span>
                                                </td> -->
                                                <td>
                                                    <span>{{ item.device_attributes&&item.device_attributes.device_sn }}</span>
                                                </td>
                                                <td>
                                                    <span>{{ item.device_attributes&&item.device_attributes.device_address }}</span>
                                                </td>
                                                <td
                                                    :class="[equipmentInfoIsInvalid(index, 'install_time') && 'errorMsg']">
                                                    <div v-if="!editType">{{item&&item.install_time}}</div>
                                                    <el-date-picker style="width: 150px" v-else
                                                        v-model="item.install_time" type="date" placeholder=""
                                                        format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                                                        @change="devicesTime(item, 'install_time')"
                                                        :teleported="false" />
                                                </td>
                                                <td
                                                    :class="[equipmentInfoIsInvalid(index, 'release_time') && 'errorMsg']">
                                                    <div v-if="!editType">{{item&&item.release_time}}</div>
                                                    <el-date-picker style="width: 150px" v-else
                                                        v-model="item.release_time" type="date" placeholder=""
                                                        format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                                                        @change="devicesTime(item, 'release_time')" 
                                                        :teleported="false"/>
                                                </td>
                                                <td
                                                    :class="[equipmentInfoIsInvalid(index, 'production_time') && 'errorMsg']">
                                                    <div v-if="!editType">{{item&&item.production_time}}</div>
                                                    <el-date-picker style="width: 150px" v-else
                                                        v-model="item.production_time" type="date" placeholder=""
                                                        format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                                                        @change="devicesTime(item, 'production_time')" 
                                                        :teleported="false"/>
                                                </td>
                                                <td>
                                                    <el-select v-if="editType" clearable style="width: 80px"
                                                        v-model="item.device_attributes.device_status"
                                                        @change="setDeviceStatus(item)" class="m-2" placeholder="">
                                                        <el-option v-for="deviceStatus in deviceStatusOptions"
                                                            :key="deviceStatus.value" :label="deviceStatus.label"
                                                            :value="deviceStatus.value" />
                                                    </el-select>
                                                    <span v-else>
                                                        {{ 
                                                        item.device_attributes&&
                                                        deviceStatusOptions.find(device=>device.value == item.device_attributes.device_status)&&
                                                        deviceStatusOptions.find(device=>device.value == item.device_attributes.device_status).label ||
                                                        '-' 
                                                        }}
                                                    </span>
                                                </td>
                                                <td
                                                    :class="[equipmentInfoIsInvalid(index, 'nameplate_attachment') && 'errorMsg']">
                                                    <div v-if="item.product_type=='1'" id="zoombox"
                                                        style="height:100px;zoom:0.5" class="d-flex align-items-center">
                                                        <div
                                                            class="w-100 d-flex flex-wrap justify-content-center align-content-between">
                                                            <el-image
                                                                v-show="item['nameplate_attachment']&&item['nameplate_attachment'].length>0"
                                                                style="width: 100px; height: 100px"
                                                                :src="imgList(item['nameplate_attachment'])[0]&&imgList(item['nameplate_attachment'])[0]"
                                                                :max-scale="7" :min-scale="0.2"
                                                                :preview-src-list="imgList(item['nameplate_attachment'])"
                                                                :initial-index="4" fit="contain" class="me-2"
                                                                :placeholder="$t(`page.auditing['暂无图片']`)" :error="$t(`page.auditing['暂无图片']`)" />
                                                            <div class="w-100 text-center fs-20">
                                                                {{imgList(item['nameplate_attachment']).length>0&&('1/'+imgList(item['nameplate_attachment']).length)||''}}
                                                            </div>
                                                        </div>
                                                        <Attr :fileCount="imgList(item['nameplate_attachment']).length"
                                                            :editType="editType" :fileId="'dropzoneFiles'+index"
                                                            :setObj="item" @filesChange="filesimgChange"></Attr>
                                                    </div>
                                                </td>
                                                <td
                                                    :class="[equipmentInfoIsInvalid(index, 'appearance_attachment') && 'errorMsg']">
                                                    <div v-if="item.product_type=='1'" style="height:100px;zoom:0.5"
                                                        class="d-flex align-items-center">
                                                        <div
                                                            class="w-100 d-flex flex-wrap justify-content-center align-content-between">
                                                            <el-image
                                                                v-show="item['appearance_attachment']&&item['appearance_attachment'].length>0"
                                                                style="width: 100px; height: 100px"
                                                                :src="imgList(item['appearance_attachment'])[0]&&imgList(item['appearance_attachment'])[0]"
                                                                :max-scale="7" :min-scale="0.2"
                                                                :preview-src-list="imgList(item['appearance_attachment'])"
                                                                :initial-index="4" fit="contain" class="me-2"
                                                                :placeholder="$t(`page.auditing['暂无图片']`)" :error="$t(`page.auditing['暂无图片']`)" />
                                                            <div class="w-100 text-center fs-20">
                                                                {{imgList(item['appearance_attachment']).length>0&&('1/'+imgList(item['appearance_attachment']).length)||''}}
                                                            </div>
                                                        </div>
                                                        <Attr1
                                                            :fileCount="imgList(item['appearance_attachment']).length"
                                                            :editType="editType" :fileId="'dropzoneFile'+index"
                                                            :setObj="item" @filesChanges="filesimgChange"></Attr1>
                                                    </div>
                                                </td>
                                                <!-- 待施工 删除按钮删除设备 -->
                                                <td v-if="!tabOptions[tabIndex].is_checkin || editType">
                                                    <template v-if="item.isParent">
                                                        <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                            hide-icon :title="$t(`page.auditing['是否删除该设备']`)"
                                                            @confirm="deleteMeasuringPoint(item)">
                                                            <template #reference>
                                                                <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                            </template>
                                                        </el-popconfirm>
                                                    </template>
                                                    <template v-else>
                                                        <span></span>
                                                    </template>
                                                </td>
                                            </template>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </b-card-body>

                    </b-card>

                    <!-- 诊断记录 -->
                    <b-card>
                        <b-card-header class="fs-14 fw-bold d-flex justify-content-between ps-0 pt-0">
                            <div class="d-flex align-items-center">
                                <div class="d-flex align-items-center">
                                    <img style="width:24px;height:26px;margin-right: 10px"
                                        src="../components/reportimg/zhenduanjilu.svg" alt="#">
                                    <div> {{  $t('page.auditing.Diagnostic Records') }} <span style="color:#9599AD;font-size: 12px;font-weight: 500;">{{  $t('page.fault.fault_description') }}</span>
                                    </div>
                                </div>
                                <div v-if="equipmentInfo.length>0&&((equipmentInfo.length-diagnosisIdList.length)== 0||(equipmentInfo.length-diagnosisIdList.length)> 0)"
                                    class="d-flex align-items-center ms-4">
                                    <template v-if="!(undiagnosedDeviceNum == 0 || undiagnosedDeviceNum < 0)">
                                        <div style="color: #B6B6B6;font-size: 13px;font-weight: 400;line-height: 100%">
                                            {{  $t('page.auditing.undiagnosed_equipment') }}：</div>
                                        <div class="d-flex align-items-center">
                                            <div
                                                style="width:17px;height:17px;border-radius: 4px;background: #ED5E5E;color:#ffffff;text-align: center;line-height: 17px">
                                                {{undiagnosedDeviceNum}}
                                            </div>
                                            <div style="width: 100px" class="ms-2">
                                                <el-progress color="['#DFE3ED','#29c26e']"
                                                    :percentage="(((diagnosisIdList.length)/(equipmentCount))*100).toFixed(2)||0" />
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div v-if="woData.status=='2'&&editType" style="width: 210px"
                                class="d-flex justify-content-end">
                                <button class="btn btn-primary d-flex align-items-center"
                                    @click="modalChange('诊断记录')"><img style="width: 14px;height: 13px;" class="me-1"
                                        src="./diagnosticrecord.svg" alt="#" /> <span>{{  $t('page.auditing.add_diagnosis') }}</span> </button>
                            </div>
                        </b-card-header>
                        <b-card-body>
                            <div class=" w-100 text-center" style="color:#909399;font-size: 14px;"
                                v-if="faultList.length === 0&&normalList.length === 0">
                                {{ $t('base.no-data') }}
                            </div>
                            <div v-if="faultList.length !== 0" class="d-flex align-items-center mb-4">
                                <div><img src="../components/reportimg/icon.svg" alt="#"></div>
                                <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{  $t('page.auditing.abnormal_equipment') }}</div>
                            </div>
                            <div v-if="faultList.length !== 0" :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(item, index) in tableHeadersAbnormal" :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr>
                                            <td colspan="100" class="text-center" style="color:#909399;font-size: 14px;"
                                                v-if="faultList.length === 0">
                                                {{ $t('base.no-data') }}
                                            </td>
                                        </tr>
                                        <tr v-for="(a,index) in faultList" :key="index+'guzhang'">
                                            <td v-show="tableHeadersAbnormal[0].visible" :rowspan="1">
                                                <div v-for="b in a.devices" :key="b.name">
                                                    {{b.name&&b.name||''}}
                                                </div>
                                            </td>
                                            <td v-show="tableHeadersAbnormal[1].visible" :rowspan="1">
                                                <div v-for="b in a.devices" :key="b.name">
                                                    <div v-for="c in b.measurement&&b.measurement" :key="c">
                                                        {{c}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td v-show="tableHeadersAbnormal[2].visible" :rowspan="1">
                                                <div v-for="b in a.diagnosis" :key="b.fault_name">
                                                    {{b.fault_name}}
                                                </div>
                                            </td>
                                            <td v-show="tableHeadersAbnormal[3].visible" :rowspan="1">
                                                <div v-for="b in a.diagnosis" :key="b.name">
                                                    <div v-for="c in b.fault_list" :key="c">
                                                        {{c.fault_reason}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td v-show="tableHeadersAbnormal[4].visible" :rowspan="1">
                                                <div v-for="b in a.diagnosis" :key="b.name">
                                                    <div v-for="c in b.fault_list" :key="c">
                                                        {{c.solution}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td v-show="tableHeadersAbnormal[5].visible" :rowspan="1">
                                                <div v-for="b in a.diagnosis" :key="b.name">
                                                    <SwiperTool :nextfalse="false" :swiperInfo="{
                                type: 'document',
                                page: 'assetform',
                                spaceBetween: 10,
                                slidesPerView: 15,
                                actionsClass: [
                                  { name: 'ri-eye-fill', action: 'view' },
                                  { name: 'ri-download-2-fill', action: 'download' },
                                ],
                              }" :list="b.attachment&&b.attachment" :nameType="false">
                                                    </SwiperTool>
                                                </div>

                                            </td>
                                            <td v-if="editType">
                                                <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                    hide-icon :title="$t(`page.auditing['是否删除该设备']`)" 
                                                    @confirm="deleteDiagnosticPoint(a)">
                                                    <template #reference>
                                                        <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                    </template>
                                                </el-popconfirm>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="normalList.length !== 0" class="d-flex align-items-center mb-4">
                                <div><img src="../components/reportimg/icon.svg" alt="#"></div>
                                <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{  $t('page.auditing.normal_equipment') }}</div>
                            </div>
                            <div v-if="normalList.length !== 0" :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(item, index) in tableHeadersNormal" :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>

                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr>
                                            <td colspan="100" class="text-center" style="color:#909399;font-size: 14px;"
                                                v-if="normalList.length === 0">
                                                {{ $t('base.no-data') }}
                                            </td>
                                        </tr>
                                        <tr v-for="(item, index) in normalList" :key="index">
                                            <!--                      <th scope="row">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <td>
                                                <div v-for="a in item.data" :key="a.device_name">{{ a.device_name }}
                                                </div>
                                            </td>
                                            <td>
                                                <div v-for="a in item.data" :key="a.device_name+'1'">{{ a.remark }}
                                                </div>
                                            </td>
                                            <td>
                                                <SwiperTool :nextfalse="false" :swiperInfo="{
                              type: 'document',
                              page: 'assetform',
                              spaceBetween: 10,
                              slidesPerView: 15,
                              actionsClass: [
                                { name: 'ri-eye-fill', action: 'view' },
                                { name: 'ri-download-2-fill', action: 'download' },
                              ],
                            }" :list="item.attachment&&item.attachment" :nameType="false">
                                                </SwiperTool>
                                            </td>

                                            <td v-if="editType">
                                                <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                    hide-icon :title="$t(`page.auditing['是否删除该设备']`)" @confirm="deleteDiagnosticPoint(item)">
                                                    <template #reference>
                                                        <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                    </template>
                                                </el-popconfirm>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </b-card-body>
                    </b-card>

                    <!-- 服务建议 -->
                    <b-card>
                        <b-card-header class="fs-14 fw-bold d-flex justify-content-between ps-0 pt-0">
                            <div class="d-flex align-items-center">
                                <div class="d-flex align-items-center">
                                    <svg style="margin-right: 10px" xmlns="http://www.w3.org/2000/svg" width="20"
                                        height="25" viewBox="0 0 20 25" fill="none">
                                        <path d="M1 4H5.29714V6.5H15.2138V4H18.7972V16.2807V23.5H9.79714H1V4Z"
                                            fill="#4C6472" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M8.01172 20.4945H16.0228V19.6934H8.01172V20.4945Z" fill="white" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M6.66706 17.8157V20.0379C6.66706 20.2423 6.50188 20.4083 6.29669 20.4083H4.07447C3.87003 20.4083 3.7041 20.2423 3.7041 20.0379V17.8157C3.7041 17.6112 3.87003 17.4453 4.07447 17.4453H6.29669C6.50188 17.4453 6.66706 17.6112 6.66706 17.8157V17.8157Z"
                                            stroke="white" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M8.01172 17.8246H15.1327V17.0234H8.01172V17.8246Z" fill="white" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M7.40723 4.7032H13.3332V1.74023H7.40723V4.7032Z" fill="white" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M6.66699 5.07407V1.37037C6.66699 1.16593 6.83292 1 7.03736 1H13.704C13.9092 1 14.0744 1.16593 14.0744 1.37037V5.07407C14.0744 5.27852 13.9092 5.44444 13.704 5.44444H7.03736C6.83292 5.44444 6.66699 5.27852 6.66699 5.07407V5.07407Z"
                                            stroke="#4C6472" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M20 2.85279V24.3343C20 24.5387 19.8348 24.7046 19.6296 24.7046H0.37037C0.165926 24.7046 0 24.5387 0 24.3343V2.85279C0 2.64835 0.165926 2.48242 0.37037 2.48242H5.18518V3.22316H0.740741V23.9639H19.2593V3.22316H15.5556V2.48242H19.6296C19.8348 2.48242 20 2.64835 20 2.85279Z"
                                            fill="#4C6472" />
                                        <path
                                            d="M16.2647 7.94291L13.7974 10.4102C13.7742 10.4334 13.7467 10.4517 13.7165 10.4642C13.6863 10.4768 13.6538 10.4832 13.6211 10.4832C13.5884 10.4832 13.556 10.4768 13.5257 10.4642C13.4955 10.4517 13.468 10.4334 13.4449 10.4102C13.4217 10.3871 13.4034 10.3596 13.3909 10.3294C13.3783 10.2991 13.3719 10.2667 13.3719 10.234C13.3719 10.2012 13.3783 10.1688 13.3909 10.1386C13.4034 10.1084 13.4217 10.0809 13.4449 10.0577L15.9122 7.59044L15.7359 7.41421L13.2686 9.88151C13.2219 9.92825 13.1585 9.95451 13.0924 9.95451C13.0263 9.95451 12.9629 9.92825 12.9162 9.88151C12.8694 9.83477 12.8432 9.77137 12.8432 9.70527C12.8432 9.63917 12.8694 9.57578 12.9162 9.52904L15.5597 6.8855C15.5829 6.86236 15.6103 6.844 15.6406 6.83147C15.6708 6.81895 15.7032 6.8125 15.7359 6.8125C15.7687 6.8125 15.8011 6.81895 15.8313 6.83147C15.8616 6.844 15.889 6.86236 15.9122 6.8855L16.9696 7.94291C16.9927 7.96606 17.0111 7.99353 17.0236 8.02377C17.0362 8.05401 17.0426 8.08642 17.0426 8.11915C17.0426 8.15188 17.0362 8.18429 17.0236 8.21453C17.0111 8.24477 16.9927 8.27224 16.9696 8.29539L14.3261 10.9389C14.3029 10.9621 14.2754 10.9804 14.2452 10.9929C14.215 11.0055 14.1826 11.0119 14.1498 11.0119C14.1171 11.0119 14.0847 11.0055 14.0544 10.9929C14.0242 10.9804 13.9967 10.9621 13.9736 10.9389C13.9504 10.9158 13.9321 10.8883 13.9196 10.8581C13.907 10.8278 13.9006 10.7954 13.9006 10.7627C13.9006 10.73 13.907 10.6975 13.9196 10.6673C13.9321 10.6371 13.9504 10.6096 13.9736 10.5865L16.4409 8.11915L16.2647 7.94291ZM12.0526 9.39157C12.0784 9.4032 12.102 9.41977 12.1231 9.44092L15.8241 13.1419C16.0578 13.3756 16.1891 13.6925 16.1891 14.023C16.1891 14.3536 16.0578 14.6705 15.8241 14.9042C15.5904 15.1379 15.2734 15.2692 14.9429 15.2692C14.6124 15.2692 14.2954 15.1379 14.0617 14.9042L10.3608 11.2033C10.3396 11.1821 10.3232 11.1583 10.3114 11.1328C9.96986 11.194 9.61857 11.1716 9.28754 11.0676C8.9565 10.9636 8.65554 10.781 8.41036 10.5355C8.12896 10.2543 7.93099 9.90068 7.83841 9.5138C7.74583 9.12692 7.76226 8.72196 7.88588 8.34385C7.89763 8.30789 7.91741 8.27507 7.94372 8.24789C7.97004 8.2207 8.0022 8.19987 8.03776 8.18696C8.07333 8.17405 8.11136 8.16941 8.14899 8.17339C8.18661 8.17737 8.22284 8.18985 8.25492 8.20991C8.38762 8.29292 8.8298 8.55851 9.57845 9.00473L9.91523 8.66407C9.46319 7.90291 9.1969 7.45968 9.12076 7.3416C9.10017 7.30965 9.08716 7.27342 9.08272 7.23567C9.07828 7.19793 9.08254 7.15967 9.09515 7.12382C9.10777 7.08797 9.12842 7.05548 9.15553 7.02883C9.18263 7.00219 9.21547 6.9821 9.25153 6.97009C9.63096 6.84356 10.0381 6.82523 10.4274 6.91715C10.8167 7.00907 11.1726 7.20762 11.4554 7.49052C11.7008 7.73567 11.8834 8.03657 11.9874 8.36754C12.0914 8.69851 12.1138 9.04972 12.0526 9.39122V9.39157ZM10.8324 10.9699L14.4142 14.5518C14.4836 14.6212 14.566 14.6763 14.6568 14.7138C14.7475 14.7514 14.8447 14.7708 14.9429 14.7708C15.0411 14.7708 15.1383 14.7514 15.229 14.7138C15.3197 14.6763 15.4022 14.6212 15.4716 14.5518C15.541 14.4823 15.5961 14.3999 15.6337 14.3092C15.6713 14.2185 15.6906 14.1212 15.6906 14.023C15.6906 13.9249 15.6713 13.8276 15.6337 13.7369C15.5961 13.6462 15.541 13.5638 15.4716 13.4943L11.8898 9.91253C11.7831 10.1443 11.636 10.3553 11.4554 10.5355C11.2751 10.7162 11.0642 10.8633 10.8324 10.9699ZM8.76283 10.183C8.96152 10.3817 9.20753 10.5265 9.47765 10.6037C9.74777 10.681 10.0331 10.6882 10.3068 10.6247C10.5805 10.5611 10.8335 10.429 11.042 10.2406C11.2504 10.0523 11.4075 9.81394 11.4984 9.54809C11.5893 9.28224 11.611 8.99763 11.5614 8.72107C11.5119 8.44452 11.3927 8.18513 11.2152 7.96736C11.0377 7.74959 10.8077 7.58061 10.5468 7.47634C10.2859 7.37207 10.0027 7.33595 9.72402 7.37138C9.87787 7.62639 10.1167 8.02698 10.442 8.57507C10.4701 8.62248 10.4818 8.67787 10.4751 8.7326C10.4684 8.78732 10.4437 8.83828 10.405 8.87749L9.79575 9.49379C9.75659 9.53331 9.70534 9.5586 9.65016 9.56563C9.59497 9.57265 9.53902 9.56101 9.49121 9.53256C8.94664 9.20829 8.54676 8.96913 8.29016 8.8144C8.26004 9.06341 8.28697 9.31602 8.36892 9.55308C8.45088 9.79014 8.5857 10.0055 8.76318 10.1827L8.76283 10.183ZM9.92034 14.2872C9.8736 14.3339 9.81021 14.3602 9.74412 14.3602C9.67803 14.3602 9.61465 14.3339 9.56791 14.2872C9.52118 14.2405 9.49492 14.1771 9.49491 14.111C9.49491 14.0449 9.52115 13.9815 9.56787 13.9348L10.9778 12.5249C11.0009 12.5017 11.0284 12.4833 11.0586 12.4708C11.0889 12.4583 11.1213 12.4518 11.154 12.4518C11.1867 12.4518 11.2192 12.4583 11.2494 12.4708C11.2796 12.4833 11.3071 12.5017 11.3303 12.5248C11.3534 12.548 11.3718 12.5755 11.3843 12.6057C11.3968 12.6359 11.4033 12.6684 11.4033 12.7011C11.4033 12.7338 11.3968 12.7662 11.3843 12.7965C11.3717 12.8267 11.3534 12.8542 11.3302 12.8773L9.92034 14.2872Z"
                                            fill="white" stroke="white" stroke-width="0.1" />
                                        <path
                                            d="M14.4298 14.2866C14.4645 14.3214 14.5057 14.3489 14.5511 14.3677C14.5965 14.3865 14.6451 14.3961 14.6942 14.3961C14.7433 14.3961 14.7919 14.3865 14.8372 14.3677C14.8826 14.3489 14.9238 14.3214 14.9585 14.2866C14.9932 14.2519 15.0208 14.2107 15.0396 14.1654C15.0583 14.12 15.068 14.0714 15.068 14.0223C15.068 13.9732 15.0583 13.9246 15.0396 13.8792C15.0208 13.8339 14.9932 13.7927 14.9585 13.7579C14.9238 13.7232 14.8826 13.6957 14.8372 13.6769C14.7919 13.6581 14.7433 13.6484 14.6942 13.6484C14.6451 13.6484 14.5965 13.6581 14.5511 13.6769C14.5057 13.6957 14.4645 13.7232 14.4298 13.7579C14.3951 13.7927 14.3676 13.8339 14.3488 13.8792C14.33 13.9246 14.3203 13.9732 14.3203 14.0223C14.3203 14.0714 14.33 14.12 14.3488 14.1654C14.3676 14.2107 14.3951 14.2519 14.4298 14.2866Z"
                                            fill="white" stroke="white" stroke-width="0.1" />
                                        <path
                                            d="M8.01659 15.5073L8.63342 14.3618L9.16213 14.1855L9.69083 14.7143L9.5146 15.243L8.36907 15.8598L8.01659 15.5073Z"
                                            fill="white" stroke="white" stroke-width="0.1" />
                                    </svg>
                                    <div>{{ $t('page.auditing.service_suggestions') }}</div>
                                </div>

                                <div v-if=" equipmentInfo.length>0 && (equipmentCount-diagnosisIdList.length) == 0"
                                    class="d-flex align-items-center ms-4">
                                    <template v-if="!(unservicedDeviceNum == 0 || unservicedDeviceNum < 0)">                                        
                                        <div style="color: #B6B6B6;font-size: 13px;font-weight: 400;line-height: 100%">
                                            {{ $t('page.auditing.no_recommended_equipment') }}</div>
                                        <div class="d-flex align-items-center">
                                            <div style="width:17px;height:17px;border-radius: 4px;background: #ED5E5E;color:#ffffff;text-align: center;line-height: 17px">
                                                {{unservicedDeviceNum}}
                                            </div>
                                            <div style="width: 100px" class="ms-2">
                                                <el-progress color="['#DFE3ED','#29c26e']"
                                                    :percentage="(((normalFaultIdList.length)/(diagnosisIdList.length))*100).toFixed(2)||0" />
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div v-if="woData.status=='2'&&editType" style="width: 210px"
                                class="d-flex justify-content-end">
                                <button class="btn btn-primary d-flex align-items-center" @click="modalChange('服务建议')">
                                    <svg class="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                        viewBox="0 0 13 13" fill="none">
                                        <rect x="0.4" y="0.4" width="12.2" height="12.2" rx="2.6" stroke="white"
                                            stroke-width="0.8" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M8.16692 2.60193C7.63931 2.14953 6.91731 1.93663 6.19531 2.01647C5.08454 2.14953 4.16816 3.0011 4.02931 4.03896C3.89046 4.91715 4.25146 5.74212 4.97346 6.27435C5.22339 6.46063 5.39 6.75336 5.39 7.0727V8.85569C5.39 9.01536 5.50108 9.14842 5.66769 9.17503V9.22826C5.69546 9.65405 6.05646 10 6.50077 10C6.94508 10 7.33385 9.65405 7.33385 9.22826V9.17503C7.50046 9.14842 7.61154 9.01536 7.61154 8.85569V7.0727C7.61154 6.75336 7.77815 6.46063 8.05585 6.27435C8.66677 5.82195 9 5.13005 9 4.38492C9 3.69301 8.69454 3.05433 8.16692 2.60193Z"
                                            fill="white" />
                                    </svg> <span>{{ $t('page.auditing.add_service') }}</span> </button>
                            </div>

                        </b-card-header>
                        <b-card-body>
                            <div v-if="maintenanceSuggestionTable.length>0" class="d-flex align-items-center mb-4">
                                <div><img src="../components/reportimg/icon.svg" alt="#"></div>
                                <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{ $t('page.auditing.maintenance') }}</div>
                            </div>
                            <div v-show="maintenanceSuggestionTable.length>0" :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(item, index) in tableHeadersMaintenanceSuggestion"
                                                :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>

                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr v-for="item in maintenanceSuggestionTable" :key="item.fault_name">
                                            <td :rowspan="1">
                                                <div v-for="a in item['devices']" :key="a">{{a}}</div>
                                            </td>
                                            <td :rowspan="1">{{item['fault_name']}}</td>
                                            <td :rowspan="1">
                                                <div class="mt-1 mb-1"
                                                    v-for="a in item['items']&&item['items']['suggestionList']"
                                                    :key="a"><svg class="me-2" xmlns="http://www.w3.org/2000/svg"
                                                        width="9" height="8" viewBox="0 0 9 8" fill="none">
                                                        <ellipse cx="4.51639" cy="4" rx="3.9866" ry="4"
                                                            fill="#6691E7" />
                                                    </svg>{{a}}</div>
                                            </td>
                                            <td v-if="editType">
                                                <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                    hide-icon :title="$t(`page.auditing['是否删除该设备']`)" @confirm="deleteServicePoint(item)">
                                                    <template #reference>
                                                        <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                    </template>
                                                </el-popconfirm>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="sparePartsList.length>0" class="d-flex align-items-center mb-4">
                                <div><img src="../components/reportimg/icon.svg" alt="#"></div>
                                <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{$t('page.auditing.spare_parts')}}</div>
                            </div>
                            <div v-show="sparePartsList.length>0" :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(item, index) in tableHeadersSpareParts" :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>

                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr v-for="(a,index) in sparePartsList" :key="a.fault_name+'spare'+index">
                                            <td :rowspan="1">
                                                <div v-for="b in a.devices" :key="b">{{b.split('$')[0]}}</div>
                                            </td>
                                            <td :rowspan="1">
                                                <div class="d-flex">
                                                    <div>{{a.fault_name}}</div>
                                                </div>
                                            </td>
                                            <td :rowspan="1">
                                                <div class="d-flex">
                                                    <div class="ms-5">
                                                        {{ repairLevel[a.items.attachmentLevel]}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td :rowspan="1">
                                                <div class="d-flex">
                                                    <div class="ms-2">{{a.devices.length}}{{$t('page.auditing.units')}}*{{a.items.attachmentNum}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td :rowspan="1">
                                                <table v-if="a.items.partsList&&a.items.partsList.length>0"
                                                    class="table table-bordered table-striped table-nowrap w-100">
                                                    <thead class="text-muted table-light">
                                                        <tr class="text-uppercase">
                                                            <th scope="col">{{$t('page.auditing.bit_no')}}</th>
                                                            <th scope="col">{{$t('page.auditing.unit_usage')}}</th>
                                                            <th scope="col">{{$t('page.auditing.name')}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="b in a.items.partsList" :key="b.id">
                                                            <th scope="row">{{b.location}}</th>
                                                            <td>{{b.quantity}}</td>
                                                            <td>
                                                                <el-popover v-if="b.name==='维修包'" placement="right"
                                                                    :width="700" trigger="click" :teleported="false">
                                                                    <template #reference>
                                                                        <div
                                                                            style="text-decoration:underline;cursor: pointer;width:50px">
                                                                            {{ b.name }}
                                                                        </div>
                                                                    </template>
                                                                    <el-table height="300" :data="b.extra_info">
                                                                        <el-table-column width="300" property="desc"
                                                                            :label="$t('page.auditing.GDNC_description')" />
                                                                        <el-table-column property="quantity"
                                                                            :label="$t('page.auditing.quantity_label')" />
                                                                        <el-table-column property="unit" :label="$t('page.work-order.device.unit')"  />
                                                                        <el-table-column property="location"
                                                                        :label="$t('page.auditing.bit_no')" />
                                                                    </el-table>
                                                                </el-popover>
                                                                <div v-else>
                                                                    {{ b.name }}
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td v-if="editType">
                                                <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                    hide-icon :title="$t(`page.auditing['是否删除该设备']`)" @confirm="deleteServicePoint(a)">
                                                    <template #reference>
                                                        <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                    </template>
                                                </el-popconfirm>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div v-if="upgradingList.length>0" class="d-flex align-items-center mb-4">
                                <div><img src="../components/reportimg/icon.svg" alt="#"></div>
                                <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{$t('page.auditing.technical_transformation')}}</div>
                            </div>
                            <div v-show="upgradingList.length>0" :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(item, index) in tableHeadersjigai" :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>

                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr v-for="(item, index) in upgradingList" :key="index">
                                            <!--                      <th scope="row">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(titleItem, titleIdx) in tableHeadersjigai"
                                                :key="titleIdx">
                                                <td v-show="titleItem.visible">
                                                    <div v-if="titleItem.label=== $t('page.auditing.equipment')">
                                                        <div v-for="a in item[titleItem.name]" :key="a">
                                                            {{a.split('$')[0]}}
                                                        </div>
                                                    </div>
                                                    <div class="whiteSpaceNormal" v-else>{{ item[titleItem.name] }}
                                                    </div>
                                                </td>
                                            </template>
                                            <td v-if="editType">
                                                <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                    hide-icon :title="$t(`page.auditing['是否删除该设备']`)" @confirm="deleteServicePoint(item)">
                                                    <template #reference>
                                                        <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                    </template>
                                                </el-popconfirm>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="weixiuList.length>0" class="d-flex align-items-center mb-4">
                                <div><img src="../components/reportimg/icon.svg" alt="#"></div>
                                <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{ $t('page.auditing.repairs') }}</div>
                            </div>
                            <div v-show="weixiuList.length>0" :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(item, index) in tableHeadersUpgrading" :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>

                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr v-for="(item, index) in weixiuList" :key="index">
                                            <!--                      <th scope="row">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(titleItem, titleIdx) in tableHeadersUpgrading"
                                                :key="titleIdx">
                                                <td v-show="titleItem.visible">
                                                    <div v-if="titleItem.label===$t('page.auditing.equipment')">
                                                        <div v-for="a in item.devices&&item.devices" :key="a">{{a}}
                                                        </div>
                                                    </div>
                                                    <div v-if="titleItem.label===$t('page.auditing.fault_performance')">
                                                        {{ item[titleItem.name] }}
                                                    </div>
                                                    <div class="whiteSpaceNormal" v-if="titleItem.label===$t('page.auditing.remarks')">
                                                        {{ item.items&&item.items.desc }}
                                                    </div>
                                                </td>
                                            </template>
                                            <td v-if="editType">
                                                <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                    hide-icon :title="$t(`page.auditing['是否删除该设备']`)" @confirm="deleteServicePoint(item)">
                                                    <template #reference>
                                                        <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                    </template>
                                                </el-popconfirm>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="tihuanList.length>0" class="d-flex align-items-center mb-4">
                                <div><img src="../components/reportimg/icon.svg" alt="#"></div>
                                <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{ $t('page.auditing.replace')}}</div>
                            </div>
                            <div v-show="tihuanList.length>0" :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(item, index) in tableHeadersUpgrading" :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>

                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr v-for="(item, index) in tihuanList" :key="index">
                                            <!--                      <th scope="row">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(titleItem, titleIdx) in tableHeadersUpgrading"
                                                :key="titleIdx">
                                                <td v-show="titleItem.visible">
                                                    <div v-if="titleItem.label===$t('page.auditing.equipment')">
                                                        <div v-for="a in item.devices&&item.devices" :key="a">{{a}}
                                                        </div>
                                                    </div>  
                                                    <div v-if="titleItem.label===$t('page.auditing.fault_performance')">
                                                        {{ item[titleItem.name] }}
                                                    </div>
                                                    <div class="whiteSpaceNormal" v-if="titleItem.label===$t('page.auditing.remarks')">
                                                        {{ item.items&&item.items.desc }}
                                                    </div>
                                                </td>
                                            </template>
                                            <td v-if="editType">
                                                <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                    hide-icon :title="$t(`page.auditing['是否删除该设备']`)" @confirm="deleteServicePoint(item)">
                                                    <template #reference>
                                                        <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                    </template>
                                                </el-popconfirm>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="careList.length>0" class="d-flex align-items-center mb-4">
                                <div><img src="../components/reportimg/icon.svg" alt="#"></div>
                                <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">Care</div>
                            </div>
                            <div v-show="careList.length>0" :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <!--                      <th scope="col" style="width: 25px">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(item, index) in tableHeadersUpgrading" :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr v-for="(item, index) in careList" :key="index">
                                            <!--                      <th scope="row">-->
                                            <!--                        <div class="form-check">-->
                                            <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                                            <!--                        </div>-->
                                            <!--                      </th>-->
                                            <template v-for="(titleItem, titleIdx) in tableHeadersUpgrading"
                                                :key="titleIdx">
                                                <td v-show="titleItem.visible">
                                                    <div v-if="titleItem.label===$t('page.auditing.equipment')">
                                                        <div v-for="a in item[titleItem.name]" :key="a">{{a}}</div>
                                                    </div>
                                                    <div v-if="titleItem.label===$t('page.auditing.fault_performance')">
                                                        {{ item.fault_name }}
                                                    </div>
                                                    <div class="whiteSpaceNormal" v-if="titleItem.label===$t('page.auditing.remarks')">
                                                        {{ item[titleItem.name] }}
                                                    </div>
                                                </td>
                                            </template>
                                            <td v-if="editType">
                                                <el-popconfirm :confirm-button-text="$t('base.ok')" :cancel-button-text="$t('base.cancel')"
                                                    hide-icon :title="$t(`page.auditing['是否删除该设备']`)" @confirm="deleteServicePoint(item)">
                                                    <template #reference>
                                                        <i class="ri-delete-bin-fill cursor-pointer"></i>
                                                    </template>
                                                </el-popconfirm>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="w-100 text-center" style="color:#909399;font-size: 14px;"
                                v-if="maintenanceSuggestionTable.length===0&&sparePartsList.length===0&&upgradingList.length===0&&weixiuList.length===0&&tihuanList.length===0&&careList.length===0">
                                {{ $t('base.no-data') }}
                            </div>
                        </b-card-body>
                    </b-card>

                    <!-- 商机转换 -->
                    <b-card>
                        <b-card-header class="fs-14 fw-bold ps-0 pt-0">
                            <div class="d-flex align-items-center">
                                <svg style="margin-right: 10px" width="23" height="23" viewBox="0 0 23 23" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="11.5" cy="11.5" r="11" stroke="#4C6472" />
                                    <circle cx="11.5" cy="11.5" r="10.0545" fill="#4C6472" stroke="white"
                                        stroke-width="0.8" />
                                    <path
                                        d="M6.32181 10.9912H17.708C17.8686 10.9912 18 10.8541 18 10.6866C18 10.5191 17.8686 10.3821 17.708 10.3821H6.9539L9.69754 7.52001C9.75222 7.46281 9.78292 7.38532 9.78292 7.30454C9.78292 7.22376 9.75222 7.14627 9.69754 7.08907C9.6427 7.03203 9.56842 7 9.49098 7C9.41354 7 9.33926 7.03203 9.28442 7.08907L6.0846 10.427C5.97585 10.5404 5.9722 10.7224 6.07219 10.8419C6.12328 10.931 6.21598 10.9912 6.32181 10.9912ZM17.708 13.0469H6.32181C6.16124 13.0469 6.02986 13.184 6.02986 13.3515C6.02986 13.519 6.16124 13.656 6.32181 13.656H17.003L14.2958 16.48C14.2411 16.5372 14.2104 16.6147 14.2104 16.6955C14.2104 16.7762 14.2411 16.8537 14.2958 16.9109C14.3507 16.968 14.4249 17 14.5024 17C14.5798 17 14.6541 16.968 14.7089 16.9109L17.9088 13.573C17.9102 13.5715 17.911 13.57 17.9124 13.5685C17.9402 13.5402 17.9622 13.5065 17.9772 13.4692C17.9923 13.4319 18 13.3919 18 13.3515C18 13.184 17.8686 13.0469 17.708 13.0469Z"
                                        fill="white" />
                                </svg>
                                <!-- 转换商机列表 -->
                                <div>{{ $t('page.auditing.opportunity_conversion') }}</div>
                            </div>
                        </b-card-header>
                        <b-card-body>
                            <div :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]">
                                <table class="table table-nowrap align-middle" id="orderTable">
                                    <thead class="text-muted table-light">
                                        <tr class="text-uppercase">
                                            <template v-for="(item, index) in tableHeadersBusiness" :key="index">
                                                <th v-show="item.visible">{{ item.label }}</th>
                                            </template>
                                            <th v-if="editType">{{ $t('base.operation') }}</th>
                                        </tr>
                                    </thead>
                                    <!-- 等待诊断记录，服务建议已完成后展示商机转换 -->
                                    <tbody class="list form-check-all" v-if="diagnosisIdList.length>0&&(diagnosisIdList.length- normalFaultIdList.length) == 0">
                                        <tr>
                                            <td colspan="100" class="text-center" style="color:#909399;font-size: 14px;"
                                                v-if="businessOpportunityConversion.length === 0">
                                                {{ $t('base.no-data') }}
                                            </td>
                                        </tr>
                                        <tr v-for="(item, index) in businessOpportunityConversion" :key="index"> 
                                            <template v-for="(titleItem, titleIdx) in tableHeadersBusiness" :key="titleIdx">
                                                <td v-show="titleItem.visible">
                                                    <div v-if="titleItem.label===$t('page.auditing.opportunity_type')">
                                                        {{ sugType[item[titleItem.name]] || '' }}
                                                    </div> 
                                                    <div v-else-if="titleItem.label===$t('page.auditing.stage')">
                                                        {{ {'1':'per-funnel','2':'Feasibility','3':'budget','4':'firm proposal','5':'negotiation'}[item[titleItem.name]] || '' }}
                                                    </div>  
                                                    <div v-else-if="titleItem.label===$t('page.auditing.estimated_value')">
                                                        {{ (('￥'+item[titleItem.name]) === '￥') ? '' : '￥'+item[titleItem.name]}}
                                                    </div> 
                                                    <div v-else-if="titleItem.label===$t('page.auditing.order_feasibility')">
                                                        {{ 
                                                            ((item[titleItem.name]+'%') === '%') ? '' : item[titleItem.name]+'%'
                                                        }}
                                                    </div>   
                                                    <div v-else>
                                                        {{ item[titleItem.name] }}
                                                    </div>   
                                                </td>
                                                <!-- <td v-show="titleItem.visible">
                                                    <div v-if="titleItem.label==='预估金额'" style="width:150px">
                                                        <el-input v-model="item[titleItem.name]" type="number"
                                                        @change="()=>{ businessOpportunityConversionAmount=0;businessOpportunityConversion.map(item=>{
                                                                businessOpportunityConversionAmount+=Number(item.amount)
                                                            })}" placeholder="预估金额">
                                                            <template #prepend>¥</template>
                                                        </el-input>
                                                    </div>
                                                    <div v-else-if="titleItem.label==='成单可行性'" style="width:150px">
                                                        <el-input v-model.number="item[titleItem.name]" @input="value=>{roleInput(value,index,titleItem.name)}" placeholder="成单可行性">
                                                            <template #append>%</template>
                                                        </el-input>
                                                    </div>
                                                    <div v-else-if="titleItem.label==='设备'"
                                                        style="width:250px;white-space: pre-wrap;">
                                                        {{ item[titleItem.name] }}
                                                    </div>
                                                    <div v-else-if="titleItem.label==='商机类型'">
                                                        {{ {'1':'保养','2':'备件','3':'技改','4':'care','5':'维修','6':'替换'}[item[titleItem.name]]  }}
                                                    </div>
                                                    <div v-else style="width:200px">
                                                        <b-form-textarea class="w-100" v-model="item[titleItem.name]"
                                                            :rows="1"></b-form-textarea>
                                                    </div>
                                                </td> -->
                                            </template>
                                            <td v-if="editType">
                                                <i class="ri-pencil-fill align-bottom me-2 cursor-pointer" @click="handleEditBusiness(item)"></i>  
                                                <!-- <i class="ri-delete-bin-5-fill align-bottom me-1 text-danger cursor-pointer" @click="handleDelBusiness(item)"></i> -->
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody class="list form-check-all" v-else>
                                        <tr>
                                            <td colspan="100" class="text-center" style="color:#909399;font-size: 14px;">
                                                {{ $t('base.no-data') }}
                                            </td>
                                        </tr> 
                                    </tbody>
                                </table>
                                <p>
                                    {{ $t('page.auditing.total') }} ：{{(diagnosisIdList.length>0&&(diagnosisIdList.length- normalFaultIdList.length) == 0)?businessOpportunityConversionAmount:0}}
                                </p>
                            </div>

                        </b-card-body>
                    </b-card>
                </el-tab-pane>
            </el-tabs>

            <!-- nav tab 右侧按钮 -->
            <div v-if="tabOptions&&tabOptions.length===0 && canEditableTab"
                class="w-100 d-flex justify-content-between mt-2">
                <div class="d-flex align-items-center">
                    <div style="color: #B6B6B6;font-size: 13px;font-weight: 400;line-height: 100%">{{ $t('page.auditing.unallocated_individual_equipment') }}：</div>
                    <div class="d-flex align-items-center">
                        <div
                            style="width:17px;height:17px;border-radius: 4px;background: #ED5E5E;color:#ffffff;text-align: center;line-height: 17px">
                            {{woData.not_assigned_device&&woData.not_assigned_device.not_assigned}}
                        </div>
                        <div style="width: 100px" class="ms-2">
                            <el-progress color="['#DFE3ED','#29c26e']"
                                :percentage="((((woData.not_assigned_device&&woData.not_assigned_device.count)-(woData.not_assigned_device&&woData.not_assigned_device.not_assigned))/(woData.not_assigned_device&&woData.not_assigned_device.count))*100).toFixed(2)||0" />
                        </div>
                    </div>
                </div>

                <div class="btn-wrap">
                    <button class="btn btn-primary" @click="addContactPerson"><i class="las la-plus"></i>
                        <span>{{ $t('page.auditing.add_contact') }}</span></button>
                    <button class="btn btn-primary" @click="modalChange('联系人')"><i class="ri-user-add-line me-1"></i>
                        <span>{{ $t('page.auditing.selcet_contact') }}</span></button>
                </div>

            </div>
            <div v-if="tabOptions&&tabOptions.length===0 && canEditableTab"
                class="w-100 h-100 d-flex justify-content-center align-content-center">

                <div class="d-flex flex-wrap justify-content-around align-content-center user-class"
                    style="margin-top: 250px" @click="modalChange('联系人')">
                    <div class="w-100 text-center"> <i class="ri-add-line"></i> </div>
                    <div class="w-100 text-center">{{ $t('page.auditing.selcet_contact') }}</div>
                </div>
            </div>


        </b-col>
    </b-row>
    <el-dialog v-model="userModal" :title="modalTitleI18[modalTitle]" :width="(modalTitle==='联系人'||modalTitle==='商机转换')?'30%':'60%'" align-center>
        <div>
            <div v-if="modalTitle==='联系人'" class="input-light d-flex align-items-start justify-content-center"
                style="height:150px">
                <Multiselect class="form-control" :placeholder="$t('page.auditing.selcet_contact')" v-model="contactPerson" :close-on-select="true"
                    :searchable="false" :create-option="false" :options="userOptions" :can-clear="false" />
            </div>

            <!--default-expand-all-->
            <el-table ref="xTable" v-show="modalTitle==='设备列表'" :data="deviceList"
                style="width: 100%; margin-bottom: 20px;" row-key="id" border @select="handleSelect"
                :header-cell-class-name="cellClass">
                <!-- <el-table-column type="selection" width="55" :selectable="callback" /> -->

                <el-table-column prop="sn" :label="$t('序列号')" width="150" />
                <el-table-column prop="model" :label="$t('设备型号')" />
                <el-table-column prop="location" :label="$t('page.auditing.position_no')" />
                <el-table-column prop="name" :label="$t('设备名称')" />
                <el-table-column :label="$t('page.auditing.contact')">
                    <template #default="scope">
                        <el-select v-if="scope.row.isParent" clearable v-model="scope.row.device_contact"
                            @change="setInstanceAttribute(scope.row)" @clear="clearInstanceAttribute(scope.row)" class="m-2" :placeholder="$t(`page.auditing['暂无联系人']`)">
                            <el-option v-for="item in userOptionsDevice" :key="item.value" :label="item.label"
                                :value="item.label" />
                        </el-select>
                        <el-select v-else disabled v-model="scope.row.device_contact" class="m-2" :placeholder="$t(`page.auditing['暂无联系人']`)">
                            <el-option v-for="item in userOptionsDevice" :key="item.value" :label="item.label"
                                :value="item.label" />
                        </el-select>
                    </template>
                </el-table-column>
            </el-table>
            <el-table v-show="modalTitle==='设备测点'" :data="measuringPointTableData"
                style="width: 100%; margin-bottom: 20px" row-key="id" border
                @selection-change="handleSelectionChange('measuringPointTableData',$event)">

                <el-table-column prop="group_type" :label="$t('Unit Name')" width="120" />
                <el-table-column prop="device_name" :label="$t('Name')" width="150" />
                <el-table-column prop="location" :label="$t('page.auditing.position_no')" width="150" />
                <el-table-column v-for="(a,index) in pointTypeList" :key="a+index" width="200">
                    <template #header>
                        <div class="text-center">{{a}}</div>
                        <div class="text-center">({{unitList[a]}})</div>
                    </template>
                    <template #default="scope">
                        <div class="d-flex align-items-center justify-content-around">
                            <b-form-input
                                type="number"
                                :style="{color:{'1':'#212529','2':'#ED5E5E','3':'#ED5E5E',height:'35px'}[scope.row.device.data[a]&&scope.row.device.data[a]['s']]}"
                                v-model="scope.row.device.data[a]['v']" class="form-control w-50" 
                                :class="`${scope.row.device.data[a]['s'] !== '1'&&(!scope.row.device.data[a]['v'])?'is-invalid':''}`" placeholder="N/A"
                                />
                            <el-select v-model="scope.row.device.data[a]['s']" class="m-2 w-50" :placeholder="$t('page.auditing.selcet_contact')">
                                <el-option :label="$t('Normal')" value="1" />
                                <el-option :label="$t('High')" value="2" />
                                <el-option v-if="!a.includes('泵')" :label="$t('Low')" value="3" />
                            </el-select>
                        </div>

                    </template>
                </el-table-column>



            </el-table>

            <div v-if="modalTitle==='诊断记录'">
                <div>
                    <p>{{ $t('page.auditing.equipment') }}</p>
                    <el-table ref="dTable" :data="sortArr(devices)" style="width: 100%; margin-bottom: 20px"
                        row-key="id" height="250" border @select="handleSelectionDevices"
                        :header-cell-class-name="cellClass">
                        <el-table-column type="selection" width="55" :selectable="callbackDevices" />
                        // 诊断记录和服务建议，设备列表增加显示机组名称字段
                        <el-table-column prop="group_name" :label="$t('Unit Name')" width="150" />
                        <el-table-column prop="name" :label="$t('Name')" />
                        <el-table-column prop="model" :label="$t('Type')"/>
                        <el-table-column prop="location" :label="$t('page.auditing.position_no')" />
                        <el-table-column prop="sn" :label="$t('序列号')" width="150" />
                        <el-table-column :label="$t(`page.auditing['是否可能异常']`)">
                            <template #default="scope">
                                {{scope.row.isNormal&&scope.row.isNormal?$t('base.yes'):$t('base.no')}}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('page.auditing.health_score')">
                            <template #default="scope">
                                <input type="number" v-if="scope.row.product_type=='1'" v-model="scope.row.score" @input="value=>{roleInputScore(scope.row,value)}"
                                    @blur="saveChanges(scope.row,$event)" @keyup.enter="saveChanges(scope.row,$event)"
                                    class="form-control" :class="[scope.row.submitted&&'is-invalid']" />

                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="mt-2">
                    <p>{{ $t('page.auditing.possible_abnormal_measurement_points') }}</p>
                    <el-table ref="diagnosticMeasuringPointTable" :data="diagnosticMeasuringPoint"
                        style="width: 100%; margin-bottom: 20px" height="250" border
                        @selection-change="handleSelectionChange('diagnosticMeasuringPoint',$event)">
                        <el-table-column type="selection" width="55" />
                        <el-table-column prop="device_location" :label="$t('page.auditing.position_no')" width="150" />
                        <el-table-column prop="key" :label="$t('page.health-monitoring.measuring_point_name')"  />
                        <el-table-column :label="$t('page.auditing.measurement_point_value')">
                            <!-- <div :style="{color:scope.row.status=='2'?'#F7B84B':'#ED5E5E'}"> -->
                            <template #default="scope">
                                <div class="text-danger">
                                    {{scope.row.value}}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="mt-2">
                    <div class="d-flex align-items-center">
                        <div>{{ $t('page.fault.fault_symptoms') }}</div>
                        <el-switch v-model="faultType" :active-text="$t(`page.auditing['是否正常']`)" inactive-text="" />
                    </div>
                    <el-tabs v-if="!faultType" v-model="faultEditableTabsValue" type="card" editable class="demo-tabs"
                        @edit="handleTabsEdit" @tabChange="handleTabsChange">
                        <el-tab-pane v-for="(item,index) in faultEditableTabs" :key="item.name"
                            :label="this.$t('Failure')+(index+1)" :name="item.name">
                            <div class="mb-4">
                                <div class="d-flex align-items-start mt-2">
                                    <div style="width:150px">{{ $t('page.auditing.fault_name') }}</div>
                                    <Multiselect class="form-control" :placeholder="$t('page.auditing.fault_name')"
                                        v-model="item.fault_knowledge_base_id" :close-on-select="true"
                                        :searchable="sortArr(devices).length?true:false" :create-option="true" :filter-results="false"
                                        :options="knowledgeBase.filter(v=>{return faultEditFilter.indexOf(v.value)===-1})"
                                        :can-clear="false" @change="getFaultKnowledgeBaseSolutions(item,$event)" />
                                </div>

                                <div class="d-flex align-items-start mt-2">
                                    <div style="width:150px">{{ $t('page.auditing.fault_description') }}</div>
                                    <b-form-textarea v-model="item.fault_desc" :rows="2"></b-form-textarea>
                                </div>

                                <!--故障原因循环-->
                                <div v-for="(a,index) in item.solutions"
                                    class="pt-2 d-flex justify-content-between align-items-end" :key="'fault'+index">
                                    <div style="width:95%">
                                        <div class="d-flex align-items-start mt-2">
                                            <div style="width:150px">{{ $t(`page.auditing['初步分析原因']`) }}{{index+1}}</div>
                                            <Multiselect class="form-control" :placeholder="$t(`page.auditing['初步分析原因']`)+(index+1)"
                                                v-model="a.fault_knowledge_base_solution_id" :close-on-select="true"
                                                :searchable="true" :create-option="true"
                                                :options="knowledgeBaseSolutionFilter.length>0?knowledgeBaseSolution.filter(v=>{return knowledgeBaseSolutionFilter.indexOf(v.value)===-1}):knowledgeBaseSolution"
                                                :can-clear="false"
                                                @change="faultKnowledgeBaseSolutionsChange(a,$event)" />
                                        </div>
                                        <div class="d-flex align-items-start mt-2">
                                            <div style="width:150px">{{ $t(`page.auditing['可能造成影响']`) }}{{index+1}}</div>
                                            <b-form-textarea v-model="a.fault_impact" :rows="2"></b-form-textarea>
                                        </div>
                                        <div class="d-flex align-items-start mt-2">
                                            <div style="width:150px">{{ $t(`page.auditing['建议解决方案']`) }}{{index+1}}</div>
                                            <b-form-textarea v-model="a.solution" :rows="2"></b-form-textarea>
                                        </div>
                                    </div>
                                    <el-button style="height:170px;width:20px" type="danger"
                                        @click="removeFault(index,item.solutions)"> <i class="ri-delete-bin-line"></i>
                                    </el-button>
                                </div>

                                <div class="d-flex justify-content-center mt-2">
                                    <button type="button" class="btn btn-light p-1" @click="addFault(item)">
                                        <i class="ri-add-line"></i>
                                    </button>
                                </div>
                                <Database v-if="userModal && (modalTitle==='诊断记录')" v-model:files="files" :filesNums="filesNums" :ID="'dropzoneFileFault'+index"
                                    @filesChange="filesChange" :faultEditableTabsValue="faultEditableTabsValue">
                                </Database>
                            </div>

                        </el-tab-pane>
                    </el-tabs>
                    <div v-else class="d-flex flex-wrap mt-2">
                        <div class="w-100 d-flex align-items-start mb-2">
                            <div style="width:150px">{{ $t('page.auditing.remarks') }}</div>
                            <b-form-textarea v-model="faultEditableTabs[0].fault_desc" :rows="2"></b-form-textarea>
                        </div>


                        <Database class="w-100" v-if="userModal && (modalTitle==='诊断记录')" v-model:files="files" :ID="'dropzoneFiles'+index" :filesNums="filesNums"
                            @filesChange="filesChange" :faultEditableTabsValue="faultEditableTabsValue"></Database>

                    </div>
                </div>
            </div>


            <div v-show="modalTitle==='服务建议'">
                <div>
                    <p>{{ $t('page.auditing.equipment') }}</p>
                    <el-table ref="sTable" :data="serviceSuggestionDevices" style="width: 100%; margin-bottom: 20px"
                        row-key="id" height="250" border @select="handleSelectionService"
                        :header-cell-class-name="cellClass">
                        <el-table-column type="selection" width="55" :selectable="callbackService" />
                        <el-table-column prop="group_name" :label="$t('Unit Name')" width="170" />
                        <el-table-column prop="name" :label="$t('Name')"  />
                        <el-table-column prop="model" :label="$t('Type')"/>
                        <el-table-column prop="location" :label="$t('page.auditing.position_no')" />
                        <el-table-column prop="sn" :label="$t('序列号')" width="150" />
                    </el-table>
                </div>
                <div>
                    <p>{{ $t('page.auditing.fault_performance') }}</p>
                    <Multiselect class="form-control" :placeholder="$t('page.auditing.fault_performance')" v-model="faultName" :close-on-select="true"
                        :searchable="false" :create-option="false" :options="faultManifestation" :can-clear="false" />
                </div>
                <div class="mt-2">
                    <p>{{ $t('page.auditing.service_suggestions') }}</p>
                    <el-tabs v-model="suggestionEditableTabsValue" type="card" editable class="demo-tabs"
                        @edit="handleTabsSuggestionEdit">
                        <el-tab-pane v-for="(item,index) in suggestionEditableTabs" :key="item.name"
                            :label="$t('page.auditing.suggestions')+(index+1)" :name="item.name">
                            <div class="mb-4" style="min-height: 250px">
                                <div class="d-flex align-items-start mt-2">
                                    <div style="width:100px">{{ $t('page.auditing.suggest_types') }}</div>
                                    <Multiselect class="form-control" :placeholder="$t('page.auditing.suggest_types')" v-model="item.type"
                                        :close-on-select="true" :searchable="false" :create-option="false"
                                        :options="suggestionNameOptions" :can-clear="false"/>
                                </div>
                                <!--保养-->
                                <div v-if="item.type==='1'">
                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px"><span class="text-danger">*</span>{{ $t('page.auditing.maintenance_type') }}</div>
                                        <el-radio-group v-model="item.maintain.suggestionType">
                                            <el-radio label="一级保养">{{  $t("overview_dynamic.service_type_dict['一级保养']")  }}</el-radio>
                                            <el-radio label="二级保养">{{  $t("overview_dynamic.service_type_dict['二级保养']")  }}</el-radio>
                                            <el-radio label="返厂大修">{{ $t("overview_dynamic.service_type_dict['返厂大修']")  }}</el-radio>
                                        </el-radio-group>
                                    </div>

                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px"><span class="text-danger">*</span>{{ $t('page.auditing.maintenance_project') }}</div>
                                        <div class="w-100">
                                            <div style="border-radius: 4px;border: 1px dashed #CED4DA;height:200px"
                                                class="overflow-auto w-100">
                                                <el-checkbox-group v-model="item.maintain.suggestionList"
                                                    class="d-flex flex-wrap">
                                                    <el-checkbox style="width:100%"
                                                        v-for="a in maintenanceSuggestionList[item.maintain.suggestionType]"
                                                        :key="a.label" :label="a.label" />
                                                </el-checkbox-group>
                                            </div>
                                            <div class="d-flex mt-2 w-100">
                                                <input type="text" class="form-control" v-model="maintenanceSuggestion"
                                                    :placeholder="$t('page.auditing.enter_maintenance_suggestions')" />
                                                <button style="width:90px" class="btn btn-success ms-2"
                                                    @click="maintenanceSuggestionChange(item)">{{ $t('添加') }}</button>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                                <!--配件-->
                                <div v-if="item.type==='2'">
                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px"><span class="text-danger">*</span>{{ $t('page.auditing.accessories_type') }}</div>
                                        <div class="d-flex align-items-center justify-content-between w-100">
                                            <Multiselect style="width: 30%" class="form-control m-0" :placeholder="$t('page.auditing.accessories_type') "
                                                v-model="item.attachment.attachmentType" :close-on-select="true"
                                                :searchable="true" :create-option="false" :options="attachmentList"
                                                :can-clear="false"
                                                @change="item.attachment.partsList=[];item.attachment.attachmentLevel=''" />
                                            <el-radio-group
                                                @change="getRepairKitComponents(item,item.attachment.attachmentType)"
                                                class="d-flex justify-content-end align-items-center" style="width: 50%"
                                                v-model="item.attachment.attachmentLevel">
                                                <el-radio label="3">{{ repairLevel['3'] }}</el-radio>
                                                <el-radio label="2">{{ repairLevel['2'] }}</el-radio>
                                                <el-radio label="1">{{ repairLevel['1'] }}</el-radio>
                                            </el-radio-group>
                                            <div style="width: 30%;"
                                                class="d-flex justify-content-end align-items-center">
                                                <div class="me-2"> {{serviceSuggestionDevicesCheckList.length}}{{$t("overview_static.device_overview_page['台']")}}*</div>
                                                <el-input-number class="w-50" v-model="item.attachment.attachmentNum"
                                                    :min="1" :max="100" />
                                            </div>
                                        </div>

                                    </div>

                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px">{{ $t('page.auditing.accessories_list') }}</div>
                                        <div style="border-radius: 4px;border: 1px dashed #CED4DA;" class="w-100 p-2">
                                            <table class="table table-striped table-nowrap w-100">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">{{ $t('page.auditing.bit_no') }}</th>
                                                        <th scope="col">{{ $t('page.auditing.unit_usage') }}</th>
                                                        <th scope="col">{{ $t('page.auditing.name') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="a in item.attachment.partsList" :key="a.id">
                                                        <th scope="row">{{a.location}}</th>
                                                        <td>{{a.quantity}}</td>
                                                        <td>
                                                            <el-popover v-if="a.name==='维修包'" placement="right"
                                                                :width="640" trigger="click" :teleported="false">
                                                                <template #reference>
                                                                    <div
                                                                        style="text-decoration:underline;cursor: pointer;width:50px">
                                                                        {{ a.name }}
                                                                    </div>
                                                                </template>
                                                                <el-table height="300" :data="a.extra_info">
                                                                    <el-table-column property="desc" :label="$t('page.auditing.GDNC_description')" />
                                                                    <el-table-column property="quantity" :label="$t('page.auditing.quantity_label')" />
                                                                    <el-table-column property="unit" :label="$t('page.work-order.device.unit')" />
                                                                    <el-table-column property="location" :label="$t('page.auditing.bit_no')" />
                                                                </el-table>
                                                            </el-popover>
                                                            <div v-else>
                                                                {{ a.name }}
                                                            </div>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <!--技改-->
                                <div v-if="item.type==='3'">
                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px"><span class="text-danger">*</span>{{ $t('设备型号') }}</div>
                                        <el-cascader ref="cascaderPanelRef" style="width: 100%"
                                            v-model="item.technicalReform.technicalReformModel" :options="objModelInfo"
                                            :props="setProps" :show-all-levels="false" :clearable="true" :size="'large'"
                                            :filterable="true" :placeholder="this.$t('page.product-info.select')"/>
                                    </div>
                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px">{{ $t('page.auditing.remarks') }}</div>
                                        <b-form-textarea v-model="item.technicalReform.desc"
                                            :rows="2"></b-form-textarea>
                                    </div>
                                </div>

                                <!--care-->
                                <div v-if="item.type==='4'">
                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px"><span class="text-danger">*</span>Care {{ $t('type') }}</div>
                                        <Multiselect class="form-control" :placeholder="`Care ${$t('type')}`"
                                            v-model="item.care.careModel" :close-on-select="true" :searchable="false"
                                            :create-option="false" :options="careOptions" :can-clear="false" />
                                    </div>
                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px">{{ $t('page.auditing.remarks') }}</div>
                                        <b-form-textarea v-model="item.care.desc" :rows="2"></b-form-textarea>
                                    </div>
                                </div>

                                <!--其他-->
                                <div v-if="item.type==='5'||item.type==='6'">
                                    <div class="d-flex align-items-start mt-2">
                                        <div style="width:100px">{{ $t('page.auditing.remarks') }}</div>
                                        <b-form-textarea v-model="item.other.desc" :rows="2"></b-form-textarea>
                                    </div>
                                </div>

                            </div>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <div v-if="modalTitle==='商机转换'"  class="flexForm">
                <el-form :model="businessFormModel" ref="ruleFormRefBusiness" :rules="getRules()" label-width="120px" label-position="top"
                status-icon>
                    <el-form-item :label="$t('page.auditing.opportunity_type')" prop="type">
                        <Multiselect class="form-control" :placeholder="$t('page.auditing.opportunity_type')" v-model="businessFormModel.type" :close-on-select="true"
                        :searchable="false" :create-option="false" :options="suggestionNameOptions" :can-clear="false" />
                    </el-form-item>   
                    <el-form-item :label="$t('page.auditing.stage')" prop="stage">
                        <Multiselect class="form-control" :placeholder="$t('page.auditing.stage')" v-model="businessFormModel.stage" :close-on-select="true"
                        :searchable="false" :create-option="false" :options="businessStage" @change="inputAmountStage"  :can-clear="false" />
                    </el-form-item>
                    <el-form-item :label="$t('page.auditing.estimated_value')" prop="amount">
                        <el-input v-model="businessFormModel.amount" type="number"> 
                            <template #prepend>¥</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('page.auditing.order_feasibility')" prop="possibility">
                        <el-input v-model.number="businessFormModel.possibility" @input="roleInput">
                            <template #prepend>%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('page.auditing.remarks')" prop="remark">
                        <el-input v-model="businessFormModel.remark" type="textarea" />
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer d-flex justify-content-end">
                <button class="btn btn-light d-flex align-items-center" @click="toggleValue"><span>{{ $t('base.cancel') }}</span></button>
                <button class="btn btn-primary d-flex align-items-center ms-2"
                    @click="saveForm()"><span>{{ $t('base.ok')}}</span></button>
            </div>
        </template>
    </el-dialog>

    <b-modal v-model="examineModal" hide-footer dialog-class="modal-dialog-centered" class="v-modal-custom" title=""
        centered>
        <div class="modal-body">
            <div v-if="examineType==='2'">
                <div class="d-flex flex-wrap justify-content-center align-content-around">
                    <img style="width:124px" src="../components/reportimg/butongguo.svg" alt="#" />
                    <div class="w-100 text-center">{{ $t('base.refuse') }}</div>
                </div>
                <div class="mt-4">{{$t("page.auditing['驳回原因']") }}:</div>
                <div>
                    <b-form-textarea class="w-100" v-model="examineDec" :rows="4"></b-form-textarea>
                </div>
            </div>
            <div v-else>
                <div class="d-flex flex-wrap justify-content-center align-content-around">
                    <img style="width:230px" src="../components/reportimg/tongguo.svg" alt="#" />
                    <div class="w-100 text-center">{{ $t('base.pass') }}</div>
                </div>
                <div class="mt-4">{{$t("page.auditing['审核通过后等待签字验收']") }}</div>
            </div>

        </div>
        <div class="modal-footer d-flex justify-content-end">
            <button class="btn btn-light d-flex align-items-center"
                @click="examineModal=!examineModal"><span>{{ $t('base.cancel') }}</span></button>
            <button class="btn btn-primary d-flex align-items-center ms-2"
                @click="savePostAuditingReviews"><span>{{ $t('base.done') }}</span></button>
        </div>
    </b-modal>

    <!-- 添加联系人弹窗 -->
    <addUpdateAccountDialog v-model:visible="addUpdateAccountDialogInfo.visible" v-bind="addUpdateAccountDialogInfo"
        type="organization" belong_type="customer" :disabledFields="['role_id']" defaultRoleCode="device_contact"
        @successed="addUpdateAccountSuccessed" />
</template>

<style scoped lang="scss">
    /* 更改折叠行的图标样式 */
    // .el-table__expand-icon {
    //   background-image: url('../../../assets/icon-cogs.png'); /* 替换为你的自定义图标路径 */
    //   background-size: cover;
    // }

    // /* 折叠行关闭时的图标样式 */
    // .el-table__expand-icon.el-table__expand-icon--expanded {
    //   background-image: url('../../../assets/check.png'); /* 折叠时的图标路径 */
    // }
    //展开el-table__expand-icon el-table__expand-icon--expanded /折叠 el-table__expand-icon
    .user-class {
        width: 110px;
        height: 100px;
        border-radius: 8px;
        border: 1px dashed #CBCCCE;
        background: rgba(33, 37, 41, 0.06);
    }

    // 自定义 - 表单校验
    .errorMsg {
        --errColor: #f06548;

        :deep(.el-input) {
            --el-input-border-color: var(--errColor);
        }

        :deep(.text-muted) {
            color: var(--errColor) !important;
        }
    }

    .btn-wrap {
        display: flex;

        .btn-primary {
            display: flex;
            align-items: center;
            justify-content: center;

            +.btn-primary {
                margin-left: 10px;
            }
        }
    }

    .topTabsButton {
        :deep(.el-tabs__new-tab) {
            width: 240px !important;
        }
    }

    .whiteSpaceNormal {
        white-space: normal;
    }

    .hideTabRow {
        :deep(.el-tabs__header) {
            display: none !important;
        }
    }
    /* 防止el-form表单label样式 */ 
    /deep/ .el-form--default.el-form--label-top .el-form-item .el-form-item__label{
        font-weight: 500 !important;
    }

    /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        border-color: #405189 !important;
        background-color: #405189 !important;
    }
</style>